(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[30],{

/***/ "3AZ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Rentals_Rentals; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.constants.js
var Portal_constants = __webpack_require__("Yd/I");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/identifiers/constants.js
var constants = __webpack_require__("YZTm");

// EXTERNAL MODULE: ./src/client/components/utils/layers/layers.constants.js
var layers_constants = __webpack_require__("RDfq");

// EXTERNAL MODULE: ./src/client/context/ServicesContext.js
var ServicesContext = __webpack_require__("2Odu");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var tracking_constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/client/components/frameworks/toast/Toast.jsx
var Toast = __webpack_require__("0x7Y");

// EXTERNAL MODULE: ./src/client/components/widgets/layer/ClosableLayer.jsx
var ClosableLayer = __webpack_require__("FK6w");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngineTrackingContext.js
var BookingEngineTrackingContext = __webpack_require__("v+bK");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/frameworks/tabs/Tabs.jsx + 1 modules
var Tabs = __webpack_require__("4/4b");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__("3voH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/hooks/use-feature-flip/useFeatureFlip.js
var useFeatureFlip = __webpack_require__("xu+1");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// EXTERNAL MODULE: ./src/client/components/utils/measure/measure.js
var measure = __webpack_require__("yJ4S");

// CONCATENATED MODULE: ./src/client/components/widgets/easy-arrival-modal/EasyArrivalModal.jsx




var __jsx = react_default.a.createElement;












var EasyArrivalModal_EasyArrivalModal = function EasyArrivalModal(_ref) {
  var className = _ref.className,
      getOverHeight = _ref.getOverHeight,
      onEasyArrivalModalClose = _ref.onEasyArrivalModalClose;

  var _useState = Object(react["useState"])(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useMeasure = Object(measure["a" /* useMeasure */])(),
      _useMeasure2 = Object(slicedToArray["a" /* default */])(_useMeasure, 2),
      bind = _useMeasure2[0],
      height = _useMeasure2[1].height;

  var _useRouter = Object(router["useRouter"])(),
      path = _useRouter.asPath;

  var _useSelector = Object(es["e" /* useSelector */])(function (state) {
    var _state$memberSpace$ca;

    return ((_state$memberSpace$ca = state.memberSpace.cart.data) === null || _state$memberSpace$ca === void 0 ? void 0 : _state$memberSpace$ca.bookingsCart) || {};
  }),
      _useSelector$cartBook = _useSelector.cartBookings,
      cartBookings = _useSelector$cartBook === void 0 ? [] : _useSelector$cartBook;

  var showEasyArrivalModal = Object(useFeatureFlip["a" /* useFeatureFlip */])('booking.showEasyArrivalModal');
  Object(react["useEffect"])(function () {
    if (getOverHeight) {
      getOverHeight(height);
    }
  }, [height, getOverHeight]);
  var isFromBE = path.startsWith('/booking');
  var isFromCC = path.startsWith('/account');
  var hasSomethingInCart = cartBookings.some(function (_ref2) {
    var isEmpty = _ref2.isEmpty;
    return !isEmpty;
  });
  var hasMargin = isFromBE || isFromCC && hasSomethingInCart;

  if (!showEasyArrivalModal) {
    return null;
  }

  return __jsx(react["Fragment"], null, __jsx("div", Object(esm_extends["a" /* default */])({}, bind, {
    className: Object(classnames_utils["a" /* classnames */])('isolate w-[405px] max-w-[calc(100vw-40px)] rounded-12 border-1 border-solid border-lightGrey bg-white', className, {
      'mb-[140px]': hasMargin
    })
  }), __jsx("button", {
    className: "text-initial flex items-center gap-10 p-10",
    onClick: function onClick() {
      return setIsOpen(true);
    },
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    alt: Object(i18n["h" /* t */])('stays.linkLabels.easyArrivalLabel'),
    name: icons["a" /* ICONS */].USER_DETAILS,
    width: "7rem"
  }), __jsx("span", {
    className: "text-14"
  }, __jsx("span", {
    className: "block font-brand text-16 font-bold text-sienna"
  }, Object(i18n["h" /* t */])('common.easyArrival.title')), __jsx("span", {
    className: "block"
  }, Object(i18n["h" /* t */])('common.easyArrival.description')), __jsx("span", {
    className: "block text-black underline"
  }, Object(i18n["h" /* t */])('common.learnAbout')))), __jsx("button", {
    className: "absolute end-0 top-0 m-10",
    "data-testid": "close-button",
    onClick: function onClick(e) {
      e.stopPropagation();
      onEasyArrivalModalClose();
    },
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "0.75rem"
  }))), isOpen && __jsx(Modal["a" /* Modal */], {
    ariaLabel: Object(i18n["h" /* t */])('common.easyArrival.info.title'),
    ariaLabelledby: constants["y" /* ID_MODAL_HEADER__EASY_ARRIVAL_INFO */],
    className: "flex flex-col items-center gap-20 p-20 text-center md:p-40",
    closeLabel: Object(i18n["h" /* t */])('common.close'),
    onClose: function onClose() {
      return setIsOpen(false);
    },
    size: "small"
  }, __jsx(Icon["a" /* Icon */], {
    className: "shrink-0",
    name: icons["a" /* ICONS */].USER_DETAILS,
    width: "4rem"
  }), __jsx(Title["a" /* Title */], {
    id: constants["y" /* ID_MODAL_HEADER__EASY_ARRIVAL_INFO */],
    theme: "title-brand-n1"
  }, Object(i18n["h" /* t */])('common.easyArrival.info.title')), __jsx("p", null, Object(i18n["h" /* t */])('common.easyArrival.info.text')), __jsx("p", {
    className: "font-bold"
  }, Object(i18n["h" /* t */])('common.easyArrival.info.ready'))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/hero/Hero.jsx
var Hero = __webpack_require__("2B1m");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: ./src/client/components/frameworks/columns/Columns.jsx + 1 modules
var Columns = __webpack_require__("bbEf");

// EXTERNAL MODULE: ./src/client/components/frameworks/filter-button/FilterButton.jsx
var FilterButton = __webpack_require__("Gf56");

// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// EXTERNAL MODULE: ./src/client/components/widgets/availability-badge/AvailabilityBadge.jsx
var AvailabilityBadge = __webpack_require__("5iTF");

// CONCATENATED MODULE: ./src/client/components/widgets/rentals-section-title/RentalsSectionTitle.jsx
var RentalsSectionTitle_jsx = react_default.a.createElement;





var RentalsSectionTitle_RentalsSectionTitle = function RentalsSectionTitle(_ref) {
  var children = _ref.children,
      className = _ref.className,
      id = _ref.id,
      _ref$isOnDemand = _ref.isOnDemand,
      isOnDemand = _ref$isOnDemand === void 0 ? false : _ref$isOnDemand;
  return RentalsSectionTitle_jsx(Title["a" /* Title */], {
    className: Object(classnames_utils["a" /* classnames */])('border-b-1 border-lightGrey justify-between', className),
    hLevel: 3,
    id: id,
    theme: "title-brand-n1"
  }, children, RentalsSectionTitle_jsx("span", {
    className: "font-sans gap-5 inline-flex shrink-0 items-center leading-1 text-14 text-black"
  }, RentalsSectionTitle_jsx(AvailabilityBadge["a" /* AvailabilityBadge */], {
    isOnDemand: isOnDemand
  }), Object(i18n["h" /* t */])(isOnDemand ? 'common.onDemand' : 'common.included')));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: ./src/client/components/frameworks/feature-card/FeatureCard.jsx
var FeatureCard = __webpack_require__("OwO1");

// EXTERNAL MODULE: ./src/client/components/widgets/upsell-booking/UpsellBooking.jsx
var UpsellBooking = __webpack_require__("lOIz");

// CONCATENATED MODULE: ./src/client/components/widgets/rental-card/RentalCard.jsx





var RentalCard_jsx = react_default.a.createElement;

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */




var RentalCard_RentalCard = function RentalCard(_ref) {
  var className = _ref.className,
      onBook = _ref.onBook,
      rental = _ref.rental;

  var _useState = Object(react["useState"])(false),
      isExpanded = _useState[0],
      setIsExpanded = _useState[1];

  if (!rental) {
    return null;
  }

  var ageRestriction = rental.ageRestriction,
      furtherInformation = rental.furtherInformation,
      id = rental.id,
      levels = rental.levels,
      longDescription = rental.longDescription,
      name = rental.name,
      sizes = rental.sizes;
  var list = [{
    label: Object(i18n["h" /* t */])('common.age'),
    value: (ageRestriction === null || ageRestriction === void 0 ? void 0 : ageRestriction.formatted) || ''
  }, {
    label: Object(i18n["h" /* t */])('common.level'),
    value: (levels || []).map(function (l) {
      return l.label;
    }).join(' - ')
  }, {
    label: Object(i18n["h" /* t */])('common.size'),
    value: (sizes === null || sizes === void 0 ? void 0 : sizes.min) ? "".concat([sizes === null || sizes === void 0 ? void 0 : sizes.min, sizes === null || sizes === void 0 ? void 0 : sizes.max].join(' - '), " ").concat(((sizes === null || sizes === void 0 ? void 0 : sizes.unit) || '').toLowerCase()) : null
  }].filter(function (l) {
    return l.value;
  });
  return RentalCard_jsx(UpsellBooking["a" /* UpsellBooking */], {
    onBook: onBook,
    upsell: rental
  }, function (_ref2) {
    var currentPrice = _ref2.currentPrice,
        isAdded = _ref2.isAdded,
        isLoading = _ref2.isLoading,
        onExpand = _ref2.onExpand,
        onSubmit = _ref2.onSubmit;
    return RentalCard_jsx("div", {
      className: "cursor-pointer",
      onClick: function onClick() {
        setIsExpanded(!isExpanded);
        onExpand && onExpand(isExpanded);
      }
    }, RentalCard_jsx(FeatureCard["a" /* FeatureCard */], {
      className: className,
      description: longDescription,
      hasReverseLayout: true,
      isAdded: isAdded,
      isLoading: isLoading,
      id: id,
      list: list,
      name: name,
      note: furtherInformation,
      onBook: onSubmit,
      isExpanded: isExpanded,
      price: currentPrice
    }));
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/rentals-filtered-list/RentalsFilteredList.jsx



var RentalsFilteredList_jsx = react_default.a.createElement;







var INITIAL_FILTER = {
  min: 0,
  max: 1440
};
var ADULT_FILTER = {
  min: 144,
  max: 1440
};
var CHILD_FILTER = {
  min: 0,
  max: 143
};
var RentalsFilteredList_RentalsFilteredList = function RentalsFilteredList(_ref) {
  var className = _ref.className,
      _ref$colsNumber = _ref.colsNumber,
      colsNumber = _ref$colsNumber === void 0 ? 3 : _ref$colsNumber,
      id = _ref.id,
      _ref$rentals = _ref.rentals,
      rentals = _ref$rentals === void 0 ? [] : _ref$rentals,
      title = _ref.title;

  var _useState = Object(react["useState"])(INITIAL_FILTER),
      filter = _useState[0],
      setFilter = _useState[1];

  if (!(rentals === null || rentals === void 0 ? void 0 : rentals.length)) {
    return null;
  }

  var list = rentals.filter(function (r) {
    return r.ageRestriction.min >= filter.min && r.ageRestriction.max <= filter.max;
  }).map(function (r) {
    return RentalsFilteredList_jsx(RentalCard_RentalCard, {
      className: "mb-20",
      key: r.name,
      rental: r
    });
  });
  return RentalsFilteredList_jsx("section", {
    className: className
  }, RentalsFilteredList_jsx(RentalsSectionTitle_RentalsSectionTitle, {
    className: "mb-20",
    id: id,
    isOnDemand: true
  }, title), rentals.length > 1 && RentalsFilteredList_jsx("div", {
    className: "scroll-x scrollbar-hidden"
  }, RentalsFilteredList_jsx("ul", {
    className: "flex mb-20 -m-5"
  }, RentalsFilteredList_jsx("li", {
    className: "p-5"
  }, RentalsFilteredList_jsx(FilterButton["a" /* FilterButton */], {
    isActive: filter === INITIAL_FILTER,
    onClick: function onClick() {
      return setFilter(INITIAL_FILTER);
    }
  }, Object(i18n["h" /* t */])('common.activities.seeAll'))), RentalsFilteredList_jsx("li", {
    className: "p-5"
  }, RentalsFilteredList_jsx(FilterButton["a" /* FilterButton */], {
    isActive: filter === ADULT_FILTER,
    onClick: function onClick() {
      return setFilter(ADULT_FILTER);
    }
  }, Object(i18n["h" /* t */])('common.adultAndTeen'))), RentalsFilteredList_jsx("li", {
    className: "p-5"
  }, RentalsFilteredList_jsx(FilterButton["a" /* FilterButton */], {
    isActive: filter === CHILD_FILTER,
    onClick: function onClick() {
      return setFilter(CHILD_FILTER);
    }
  }, Object(i18n["h" /* t */])('common.child'))))), list.length ? RentalsFilteredList_jsx(Columns["a" /* Columns */], {
    colsNumber: colsNumber
  }, list) : RentalsFilteredList_jsx(Notification["a" /* Notification */], {
    text: Object(i18n["h" /* t */])('common.rentals.noRentalsMessage')
  }));
};
// EXTERNAL MODULE: ./src/client/components/utils/activities/activities.utils.js
var activities_utils = __webpack_require__("8W+g");

// CONCATENATED MODULE: ./src/client/components/widgets/layer-rentals/LayerRentalsBody.jsx









var LayerRentalsBody_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var getCols = function getCols(isDesktop, isTablet) {
  if (isDesktop) {
    return 3;
  }

  if (isTablet) {
    return 2;
  }

  return 1;
};

var LayerRentalsBody_LayerRentalsBody = function LayerRentalsBody(_ref) {
  var image = _ref.image,
      _ref$rentalsTree = _ref.rentalsTree,
      rentalsTree = _ref$rentalsTree === void 0 ? [] : _ref$rentalsTree;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop,
      isTablet = _useResponsive.isTablet;

  var _useState = Object(react["useState"])(0),
      overHeight = _useState[0],
      setOverHeight = _useState[1];

  var _useState2 = Object(react["useState"])(true),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var getOverHeight = function getOverHeight(height) {
    setOverHeight(height);
  };

  if (!(rentalsTree === null || rentalsTree === void 0 ? void 0 : rentalsTree.length)) {
    return null;
  }

  var cols = getCols(isDesktop, isTablet);
  var items = rentalsTree.filter(function (useCase) {
    return !!useCase.items.length;
  }).map(function (useCase) {
    return {
      header: {
        title: useCase.label
      },
      headerId: useCase.id,
      panelId: "panel-".concat(useCase.id),
      content: useCase.items.filter(function (type) {
        return !!type.items.length;
      }).map(function (type) {
        return LayerRentalsBody_jsx(RentalsFilteredList_RentalsFilteredList, {
          className: "my-40",
          colsNumber: cols,
          id: type.id,
          key: type.id,
          rentals: Object(activities_utils["h" /* sortCategoryOnDemandActivitiesByStartingPrice */])(type.items),
          title: type.label
        });
      })
    };
  });
  return LayerRentalsBody_jsx(react["Fragment"], null, LayerRentalsBody_jsx(Hero["a" /* Hero */], {
    className: "bg-darkGrey",
    size: "medium",
    url: image
  }), LayerRentalsBody_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "py-40 pb-100",
    style: _objectSpread({}, overHeight && {
      paddingBottom: overHeight + 130
    })
  }, LayerRentalsBody_jsx(Tabs["a" /* Tabs */], {
    id: "rentals",
    isContentUnmountedOnCollapse: true,
    isScrollable: true,
    items: items,
    scrollBackwardLabel: Object(i18n["h" /* t */])('common.scrollBackward'),
    scrollForwardLabel: Object(i18n["h" /* t */])('common.scrollForward'),
    message: Object(i18n["h" /* t */])('booking.activities.rentals.priceAndAvailibiltyInformations')
  }), isOpen && LayerRentalsBody_jsx(EasyArrivalModal_EasyArrivalModal, {
    className: "fixed bottom-0 left-1/2 z-1 mb-20 -translate-x-1/2 transform",
    getOverHeight: getOverHeight,
    onEasyArrivalModalClose: function onEasyArrivalModalClose() {
      return setIsOpen(false);
    }
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/layer-rentals/LayerRentals.jsx








var LayerRentals_jsx = react_default.a.createElement;

function LayerRentals_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function LayerRentals_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { LayerRentals_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { LayerRentals_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var LayerRentals_LayerRentals = function LayerRentals(_ref) {
  var forwardRef = _ref.forwardRef,
      image = _ref.image,
      layerName = _ref.layerName,
      _ref$rentalsTree = _ref.rentalsTree,
      rentalsTree = _ref$rentalsTree === void 0 ? [] : _ref$rentalsTree,
      title = _ref.title,
      tracking = _ref.tracking;

  var _useContext = Object(react["useContext"])(ServicesContext["a" /* ServicesContext */]),
      updateInfo = _useContext.updateInfo,
      setUpdateInfo = _useContext.setUpdateInfo;

  var beEngineTrackingContext = Object(react["useContext"])(BookingEngineTrackingContext["a" /* BookingEngineTrackingContext */]);
  var toasterRef = Object(react["useRef"])();

  if (!(rentalsTree === null || rentalsTree === void 0 ? void 0 : rentalsTree.length)) {
    return null;
  }

  var stateTracking = tracking || {
    pageName: tracking_constants["H" /* TRACK_PAGE_NAMES */].BE_LAYER_SKI_ACTIVITIES,
    payload: LayerRentals_objectSpread({}, beEngineTrackingContext)
  };

  var header = LayerRentals_jsx(Title["a" /* Title */], {
    className: "w-full justify-center",
    id: constants["j" /* ID_LAYER_HEADER__CA__RENTALS */],
    theme: "title-brand-n4"
  }, title);

  return LayerRentals_jsx(ClosableLayer["a" /* ClosableLayer */], {
    ariaLabel: title,
    ariaLabelledby: constants["j" /* ID_LAYER_HEADER__CA__RENTALS */],
    bgColor: colors["a" /* COLORS */].WHITE,
    externalFocusTrapRefs: [forwardRef, toasterRef],
    hasAnimateEnter: true,
    header: header,
    name: layerName || layers_constants["h" /* LAYER_NAME_UPSELL_RENTALS */],
    params: ['id', 'catId', 'stayId'],
    tracking: stateTracking
  }, LayerRentals_jsx(Toast["a" /* Toast */], {
    color: colors["a" /* COLORS */].SIENNA,
    isFixed: true,
    onClose: function onClose() {
      return setUpdateInfo && setUpdateInfo(null);
    },
    portalName: Portal_constants["b" /* AFTER_APP */],
    ref: toasterRef,
    visible: !!updateInfo
  }, LayerRentals_jsx("span", {
    className: "flex items-center gap-10"
  }, !!(updateInfo === null || updateInfo === void 0 ? void 0 : updateInfo.itemsNumber) && LayerRentals_jsx("span", {
    className: "inline-flex size-30 shrink-0 items-center justify-center rounded-full bg-success p-5 text-white"
  }, "+", updateInfo.itemsNumber), updateInfo === null || updateInfo === void 0 ? void 0 : updateInfo.message)), LayerRentals_jsx(LayerRentalsBody_LayerRentalsBody, {
    image: image,
    rentalsTree: rentalsTree
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/rentals/Rentals.jsx
var Rentals_jsx = react_default.a.createElement;



var Rentals_Rentals = function Rentals(_ref) {
  var forwardRef = _ref.forwardRef,
      image = _ref.image,
      layerName = _ref.layerName,
      rentalsTree = _ref.rentalsTree,
      title = _ref.title,
      tracking = _ref.tracking;

  if (!(rentalsTree === null || rentalsTree === void 0 ? void 0 : rentalsTree.length)) {
    return null;
  }

  var tle = title || Object(i18n["h" /* t */])('common.rentals.title');
  var imageSrc = image || Object(i18n["h" /* t */])('common.rentals.image');
  return Rentals_jsx(LayerRentals_LayerRentals, {
    forwardRef: forwardRef,
    image: imageSrc,
    layerName: layerName,
    rentalsTree: rentalsTree,
    title: tle,
    tracking: tracking
  });
};

/***/ }),

/***/ "BGO8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Childcare_Childcare; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("tQbP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("3yYM");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/hooks/use-disclosure/useDisclosure.js
var useDisclosure = __webpack_require__("Re84");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/product/product.utils.js
var product_utils = __webpack_require__("C9cF");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: ./src/client/components/frameworks/capsule/Capsule.jsx + 1 modules
var Capsule = __webpack_require__("jldR");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/widgets/service-block/ServiceBlockCTA.jsx



var __jsx = react_default.a.createElement;




var ServiceBlockCTA_ServiceBlockCTA = function ServiceBlockCTA(_ref) {
  var addLabel = _ref.addLabel,
      button = _ref.button,
      dataSelector = _ref.dataSelector,
      equipment = _ref.equipment,
      includedLabel = _ref.includedLabel,
      price = _ref.price,
      removeLabel = _ref.removeLabel,
      type = _ref.type;
  var labelAdd = price ? "".concat(addLabel, " +").concat(price) : addLabel;
  var labelRemove = price ? "".concat(removeLabel, " -").concat(price) : removeLabel;
  var dataSelectorTestID = "".concat(dataSelector, "-").concat(type !== null && type !== void 0 ? type : '');

  var _useState = Object(react["useState"])(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var handleClick = /*#__PURE__*/function () {
    var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var _button$onClick;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsLoading(true);
              _context.next = 3;
              return (_button$onClick = button.onClick) === null || _button$onClick === void 0 ? void 0 : _button$onClick.call(button);

            case 3:
              setIsLoading(false);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  switch (type) {
    case 'add':
      return __jsx(Button["a" /* Button */], {
        className: "w-full",
        "data-cs-override-idd": button === null || button === void 0 ? void 0 : button.dataCsOverrideId,
        "data-selector": "".concat(equipment.id, "-ADD"),
        "data-testid": dataSelectorTestID,
        isLoading: isLoading,
        onClick: function onClick() {
          handleClick();
        },
        size: "medium"
      }, labelAdd);

    case 'remove':
    case 'edit':
      return __jsx(Button["a" /* Button */], {
        className: "w-full",
        color: colors["a" /* COLORS */].BLACK,
        colorBg: colors["a" /* COLORS */].TRANSPARENT,
        colorBorder: colors["a" /* COLORS */].BLACK,
        "data-cs-override-id": button === null || button === void 0 ? void 0 : button.dataCsOverrideId,
        "data-selector": "".concat(equipment.id, "-EDIT"),
        "data-testid": "".concat(dataSelector, "-").concat(type),
        isLoading: isLoading,
        onClick: function onClick() {
          handleClick();
        },
        size: "medium"
      }, labelRemove);

    case 'disabled':
      return __jsx(Button["a" /* Button */], {
        className: "w-full",
        "data-cs-override-id": button === null || button === void 0 ? void 0 : button.dataCsOverrideId,
        "data-selector": "".concat(dataSelector, "-").concat(type),
        "data-testid": "".concat(dataSelector, "-").concat(type),
        isDisabled: true,
        onClick: handleClick,
        size: "medium"
      }, (button === null || button === void 0 ? void 0 : button.label) || includedLabel);

    case 'full':
      return __jsx(Button["a" /* Button */], {
        className: "w-full",
        "data-cs-override-id": button === null || button === void 0 ? void 0 : button.dataCsOverrideId,
        "data-selector": "".concat(dataSelector, "-").concat(type),
        "data-testid": "".concat(dataSelector, "-").concat(type),
        isDisabled: true,
        onClick: handleClick,
        size: "medium"
      }, (button === null || button === void 0 ? void 0 : button.label) || includedLabel);

    default:
      return null;
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/service-block/ServiceBlock.jsx


var ServiceBlock_jsx = react_default.a.createElement;

/* eslint-disable clubmed/no-fake-component */









var ServiceBlock_ServiceBlock = function ServiceBlock(_ref) {
  var _ref$addLabel = _ref.addLabel,
      addLabel = _ref$addLabel === void 0 ? '' : _ref$addLabel,
      button = _ref.button,
      className = _ref.className,
      _ref$dataSelector = _ref.dataSelector,
      dataSelector = _ref$dataSelector === void 0 ? 'ServiceBlock' : _ref$dataSelector,
      equipment = _ref.equipment,
      header = _ref.header,
      image = _ref.image,
      _ref$includedLabel = _ref.includedLabel,
      includedLabel = _ref$includedLabel === void 0 ? '' : _ref$includedLabel,
      intro = _ref.intro,
      isPriceForAdultOnly = _ref.isPriceForAdultOnly,
      isValidated = _ref.isValidated,
      lastAvailabilities = _ref.lastAvailabilities,
      _ref$price = _ref.price,
      price = _ref$price === void 0 ? '' : _ref$price,
      _ref$removeLabel = _ref.removeLabel,
      removeLabel = _ref$removeLabel === void 0 ? '' : _ref$removeLabel,
      slots = _ref.slots,
      style = _ref.style,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'add' : _ref$type,
      urgentisation = _ref.urgentisation,
      rentedAmount = _ref.rentedAmount;

  var _useState = Object(react["useState"])(false),
      shouldDisplayMoreDetails = _useState[0],
      setShouldDisplayMoreDetails = _useState[1];

  var isDisabled = type === 'disabled';
  var isFull = type === 'full';
  var additionalStyle = {
    label: {
      fontSize: '14px'
    },
    icon: {
      display: 'flex',
      width: '1rem'
    }
  };

  var toggleDisplayMoreDetails = function toggleDisplayMoreDetails() {
    setShouldDisplayMoreDetails(!shouldDisplayMoreDetails);
  };

  return ServiceBlock_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(className, 'isolate flex-none py-5'),
    "data-testid": "ServiceBlock",
    style: style
  }, ServiceBlock_jsx(Capsule["a" /* Capsule */], Object(esm_extends["a" /* default */])({}, header, {
    additionalStyle: additionalStyle
  }), !!image && ServiceBlock_jsx("div", {
    className: "relative isolate z-1"
  }, ServiceBlock_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('bg-cover bg-center bg-no-repeat', {
      'opacity-1 pt-[calc((4/7)*100%)]': !shouldDisplayMoreDetails,
      'opacity-0': shouldDisplayMoreDetails
    }),
    style: {
      backgroundImage: "url(".concat(image, ")"),
      transition: 'padding-top 0.2s linear, opacity 0.2s linear'
    }
  }), !shouldDisplayMoreDetails ? lastAvailabilities : null), ServiceBlock_jsx("div", {
    className: "relative p-10 font-sans text-14"
  }, isValidated && !isFull ? ServiceBlock_jsx("div", {
    className: "relative"
  }, ServiceBlock_jsx("div", {
    className: "absolute left-[-23px] right-[-23px] top-[-26px] flex justify-end"
  }, ServiceBlock_jsx(Icon["a" /* Icon */], {
    className: "text-success",
    name: icons["a" /* ICONS */].CHECK_OUTLINE,
    width: "3.75rem"
  }))) : null, ServiceBlock_jsx("h3", {
    className: "font-brand text-20 font-bold leading-1 text-black"
  }, equipment.label), (slots === null || slots === void 0 ? void 0 : slots.length) > 0 && ServiceBlock_jsx("ul", {
    className: "pt-10"
  }, slots.map(function (slot) {
    return ServiceBlock_jsx("li", {
      className: "flex gap-10 py-5",
      "data-testid": slot.key || slot.label,
      key: slot.key || slot.label
    }, ServiceBlock_jsx(Icon["a" /* Icon */], {
      className: "shrink-0 text-sienna",
      name: slot.icon,
      width: "1.5rem"
    }), ServiceBlock_jsx("div", null, ServiceBlock_jsx("p", {
      className: "text-14"
    }, slot.label), !!slot.disclaimer && ServiceBlock_jsx("p", {
      className: "text-12"
    }, slot.disclaimer)));
  })), equipment.longDescription ? ServiceBlock_jsx(react["Fragment"], null, ServiceBlock_jsx(lib["Collapse"], {
    theme: {
      content: 'flex flex-col gap-10'
    },
    isOpened: shouldDisplayMoreDetails
  }, intro ? ServiceBlock_jsx("p", {
    className: "text-12"
  }, intro) : null, typeof equipment.longDescription === 'string' ? ServiceBlock_jsx(Text["a" /* Text */], {
    text: equipment.longDescription,
    theme: "text-sans-n2"
  }) : equipment.longDescription), ServiceBlock_jsx("button", {
    className: "ms-auto inline-flex items-center gap-5 py-10 text-14 text-black underline",
    onClick: toggleDisplayMoreDetails,
    type: "button"
  }, shouldDisplayMoreDetails ? ServiceBlock_jsx(react["Fragment"], null, Object(i18n["h" /* t */])('common.loadLess'), "\xA0", ServiceBlock_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].MINUS,
    width: "0.625rem"
  })) : ServiceBlock_jsx(react["Fragment"], null, Object(i18n["h" /* t */])('common.loadMore'), "\xA0", ServiceBlock_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].PLUS,
    width: "0.625rem"
  })))) : null, urgentisation && !isFull && ServiceBlock_jsx("div", {
    className: "flex items-center justify-center",
    "data-testid": "urgentisationBlock"
  }, urgentisation), isFull && Object(i18n["h" /* t */])('booking.services.childcare.babySittingService') !== '' && ServiceBlock_jsx("p", {
    className: "mb-15 text-12 text-orange"
  }, Object(i18n["h" /* t */])('booking.services.childcare.babySittingService')), ServiceBlock_jsx(ServiceBlockCTA_ServiceBlockCTA, {
    addLabel: addLabel,
    button: button,
    dataSelector: dataSelector,
    equipment: equipment,
    includedLabel: includedLabel,
    price: type === 'remove' || type === 'edit' ? rentedAmount : price,
    removeLabel: removeLabel,
    type: type
  }), !isDisabled && !isFull && button && ServiceBlock_jsx("p", {
    className: "mt-10 text-center text-10"
  }, isPriceForAdultOnly ? Object(i18n["h" /* t */])('booking.common.pricePerAdult') : Object(i18n["h" /* t */])('booking.common.pricePerPerson')))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/reservation-block/PopInReservationBlock.jsx + 7 modules
var PopInReservationBlock = __webpack_require__("YOo2");

// EXTERNAL MODULE: ./logger/logger.js
var logger = __webpack_require__("zytj");

// EXTERNAL MODULE: ./src/client/components/widgets/reservation-block/PopInReservationBlockMorningAfternoonExclusive.jsx
var PopInReservationBlockMorningAfternoonExclusive = __webpack_require__("fYIP");

// EXTERNAL MODULE: ./src/client/context/ChildcareContext.js
var ChildcareContext = __webpack_require__("7afx");

// CONCATENATED MODULE: ./src/client/tracking/events/cart.tracking.js









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var TRACK_ACTION_CART_ADD = {
  actionGA: 'addToCart'
};
var TRACK_ACTION_CART_REMOVE = {
  actionGA: 'removeFromCart'
}; // ADD/REMOVE

var TRACK_CLICK_EVENT_CART_ADD_RENTAL = _objectSpread(_objectSpread({}, TRACK_ACTION_CART_ADD), {}, {
  labelGA: 'ski'
});
var TRACK_CLICK_EVENT_CART_REMOVE_RENTAL = _objectSpread(_objectSpread({}, TRACK_ACTION_CART_REMOVE), {}, {
  labelGA: 'ski'
});
// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/utils/childcare/childcare.utils.js
var childcare_utils = __webpack_require__("erJz");

// EXTERNAL MODULE: ./src/utils/childcare/childcare.consts.js
var childcare_consts = __webpack_require__("gzwZ");

// CONCATENATED MODULE: ./src/client/components/widgets/childcare/UrgentisationChildcareBlock.jsx



var UrgentisationChildcareBlock_jsx = react_default.a.createElement;





var UrgentisationChildcareBlock_getMinRemainingStock = function getMinRemainingStock(_ref) {
  var _childcare$pricingInf, _childcare$pricingInf2, _childcare$pricingInf3;

  var childcare = _ref.childcare;

  if (!((_childcare$pricingInf = childcare.pricingInfo) === null || _childcare$pricingInf === void 0 ? void 0 : _childcare$pricingInf.schedules)) {
    return 0;
  }

  var remainingStockSchedules = (_childcare$pricingInf2 = childcare.pricingInfo) === null || _childcare$pricingInf2 === void 0 ? void 0 : (_childcare$pricingInf3 = _childcare$pricingInf2.schedules) === null || _childcare$pricingInf3 === void 0 ? void 0 : _childcare$pricingInf3.map(function (_ref2) {
    var _slots$map;

    var slots = _ref2.slots;
    var stockSlots = (slots === null || slots === void 0 ? void 0 : (_slots$map = slots.map(function (_ref3) {
      var remainingStock = _ref3.remainingStock;
      return remainingStock;
    })) === null || _slots$map === void 0 ? void 0 : _slots$map.filter(function (rs) {
      return rs > 0;
    })) || [];
    var minStockSlots = stockSlots.length > 0 ? Math.min.apply(Math, Object(toConsumableArray["a" /* default */])(stockSlots)) : 0;
    return minStockSlots;
  });
  var minRemainingStock = Math.min.apply(Math, Object(toConsumableArray["a" /* default */])(remainingStockSchedules));
  return minRemainingStock;
};
var UrgentisationChildcareBlock_UrgentisationChildcareBlock = function UrgentisationChildcareBlock(_ref4) {
  var childcare = _ref4.childcare,
      type = _ref4.type,
      _ref4$isByDayChildcar = _ref4.isByDayChildcare,
      isByDayChildcare = _ref4$isByDayChildcar === void 0 ? false : _ref4$isByDayChildcar,
      _ref4$isFullStayHalfD = _ref4.isFullStayHalfDayChildcare,
      isFullStayHalfDayChildcare = _ref4$isFullStayHalfD === void 0 ? false : _ref4$isFullStayHalfD;
  // here we show the min remaining stock of all schedules slots of the childcare
  var minRemainingStock = UrgentisationChildcareBlock_getMinRemainingStock({
    childcare: childcare
  });

  if (type === 'add' && !!minRemainingStock) {
    if (isByDayChildcare || isFullStayHalfDayChildcare) {
      return UrgentisationChildcareBlock_jsx("p", {
        className: "flex gap-5 items-center justify-center my-10 text-orange",
        "data-testid": "urgentisationBlock"
      }, UrgentisationChildcareBlock_jsx("span", {
        "data-testid": "urgentisationBlock-label"
      }, Object(i18n["h" /* t */])('booking.services.childcare.urgentisation')));
    }

    return UrgentisationChildcareBlock_jsx("p", {
      className: "flex gap-5 items-center justify-center my-10 text-orange",
      "data-testid": "urgentisationBlock"
    }, minRemainingStock <= childcare_consts["b" /* CHILDCARE_STOCK_THRESHOLD */] && UrgentisationChildcareBlock_jsx(Icon["a" /* Icon */], {
      "data-testid": "ServiceBlock-icon-urgentisation",
      name: icons["a" /* ICONS */].WARNING,
      width: "1.5em"
    }), UrgentisationChildcareBlock_jsx("span", {
      "data-testid": "urgentisationBlock-label"
    }, minRemainingStock <= childcare_consts["b" /* CHILDCARE_STOCK_THRESHOLD */] ? Object(i18n["h" /* t */])('booking.services.childcare.childcareAvailabilities', {
      count: minRemainingStock
    }) : Object(i18n["h" /* t */])('booking.services.childcare.urgentisation')));
  }

  return null;
};
// CONCATENATED MODULE: ./src/client/components/widgets/childcare/ChildcareServiceBlock.jsx















var ChildcareServiceBlock_jsx = react_default.a.createElement;


function ChildcareServiceBlock_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ChildcareServiceBlock_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ChildcareServiceBlock_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ChildcareServiceBlock_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




















// tag showing for last 10 availabilities
var ChildcareServiceBlock_LastAvailabilitiesTag = function LastAvailabilitiesTag(_ref) {
  var childcare = _ref.childcare,
      type = _ref.type;
  var minRemainingStock = UrgentisationChildcareBlock_getMinRemainingStock({
    childcare: childcare
  });
  var hasMoreStockThanThreshold = Object(childcare_utils["d" /* isBabyOrPetitCM */])(childcare) && minRemainingStock > childcare_consts["b" /* CHILDCARE_STOCK_THRESHOLD */];

  if (type === 'full' || type === 'remove' || childcare.productInfo.isIncluded || hasMoreStockThanThreshold) {
    return null;
  }

  return ChildcareServiceBlock_jsx("div", {
    className: "absolute bottom-0 m-10 rounded-pill bg-lightSand px-10 py-5 text-12 font-bold text-orange"
  }, Object(i18n["h" /* t */])('booking.services.childcare.lastAvailabilities'));
};

var ChildcareServiceBlock_ChildcareServiceBlock = function ChildcareServiceBlock(_ref2) {
  var _childcare$pricingInf2, _childcare$pricingInf3, _childcare$pricingInf4, _childcare$pricingInf5, _childcare$pricingInf6, _childcare$productInf, _childcare$productInf2;

  var className = _ref2.className,
      dataCsOverrideId = _ref2.dataCsOverrideId,
      isIncluded = _ref2.isIncluded,
      childcare = _ref2.childcare,
      childId = _ref2.childId,
      childBirthdateMessage = _ref2.childBirthdateMessage,
      onCtaClick = _ref2.onCtaClick,
      type = _ref2.type,
      blockMinHeight = _ref2.blockMinHeight,
      _ref2$dataTestId = _ref2.dataTestId,
      dataTestId = _ref2$dataTestId === void 0 ? '' : _ref2$dataTestId,
      _ref2$shouldTriggerCh = _ref2.shouldTriggerChildcareAdvancedReservationBlockOnClick,
      shouldTriggerChildcareAdvancedReservationBlockOnClick = _ref2$shouldTriggerCh === void 0 ? false : _ref2$shouldTriggerCh,
      _ref2$shouldTriggerCh2 = _ref2.shouldTriggerChildcareMorningAfternoonExclusiveBlockOnClick,
      shouldTriggerChildcareMorningAfternoonExclusiveBlockOnClick = _ref2$shouldTriggerCh2 === void 0 ? false : _ref2$shouldTriggerCh2;

  var _useDisclosure = Object(useDisclosure["a" /* useDisclosure */])(),
      isChildcareAdvancedReservationBlockOpen = _useDisclosure.isOpen,
      setChildcareBlockAdvancedClosed = _useDisclosure.onClose,
      setChildcareAdvancedBlockOpen = _useDisclosure.onOpen;

  var _useDisclosure2 = Object(useDisclosure["a" /* useDisclosure */])(),
      isChildcareMorningAfternoonExclusiveRBOpen = _useDisclosure2.isOpen,
      setChildcareMorningAfternoonExclusiveRBClosed = _useDisclosure2.onClose,
      setChildcareMorningAfternoonExclusiveRBOpen = _useDisclosure2.onOpen;

  var _useState = Object(react["useState"])(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _useContext = Object(react["useContext"])(ChildcareContext["a" /* ChildcareContext */]),
      updateService = _useContext.updateService,
      deleteAttendeeChildcare = _useContext.deleteAttendeeChildcare;

  var router = Object(next_router["useRouter"])();

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var track = Object(useTracking["a" /* useTracking */])(); // to remove once the comparator is fully migrated to ga4

  var isComparatorView = router.pathname === '/comparator';

  var onClickChildcareButton = function onClickChildcareButton() {
    var _childcare$pricingInf;

    var currentAttendee = (_childcare$pricingInf = childcare.pricingInfo.attendees) === null || _childcare$pricingInf === void 0 ? void 0 : _childcare$pricingInf.find(function (_ref3) {
      var id = _ref3.id;
      return id === childId;
    });

    if (shouldTriggerChildcareAdvancedReservationBlockOnClick) {
      var noRemainingStockAdvanced = currentAttendee === null || currentAttendee === void 0 ? void 0 : currentAttendee.schedules.every(function (_ref4) {
        var timeSlots = _ref4.timeSlots;
        return timeSlots.every(function (_ref5) {
          var remainingStock = _ref5.remainingStock;
          return remainingStock === 0;
        });
      });
      return ChildcareServiceBlock_objectSpread({
        onClick: function onClick() {
          // to remove once the comparator is fully migrated to ga4
          isComparatorView ? track(ChildcareServiceBlock_objectSpread(ChildcareServiceBlock_objectSpread({}, TRACK_ACTION_CART_ADD), {}, {
            labelGA: constants["f" /* CHILDCARE_TRACKING */].ADD_CHILDCARE
          })) : trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_UPSELL, {
            detail_click: constants["f" /* CHILDCARE_TRACKING */].ADD_CHILDCARE
          });
          setChildcareAdvancedBlockOpen();
        }
      }, noRemainingStockAdvanced && {
        label: Object(i18n["h" /* t */])('booking.services.childcare.childcareFull')
      });
    }

    if (shouldTriggerChildcareMorningAfternoonExclusiveBlockOnClick) {
      return ChildcareServiceBlock_objectSpread(ChildcareServiceBlock_objectSpread({
        onClick: function () {
          var _onClick = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
            var _currentAttendee$sche, _currentAttendee$sche2, _currentAttendee$sche3;

            var currentAttendeeHasRentedSomeSlot;
            return regenerator_default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    currentAttendeeHasRentedSomeSlot = currentAttendee === null || currentAttendee === void 0 ? void 0 : (_currentAttendee$sche = currentAttendee.schedules) === null || _currentAttendee$sche === void 0 ? void 0 : (_currentAttendee$sche2 = _currentAttendee$sche[0]) === null || _currentAttendee$sche2 === void 0 ? void 0 : (_currentAttendee$sche3 = _currentAttendee$sche2.timeSlots) === null || _currentAttendee$sche3 === void 0 ? void 0 : _currentAttendee$sche3.some(function (_ref6) {
                      var isRented = _ref6.isRented;
                      return isRented;
                    });

                    if (!currentAttendeeHasRentedSomeSlot) {
                      _context.next = 6;
                      break;
                    }

                    _context.next = 4;
                    return deleteAttendeeChildcare({
                      attendeeId: childId || '',
                      pricingInfo: childcare.pricingInfo
                    });

                  case 4:
                    _context.next = 8;
                    break;

                  case 6:
                    // to remove once the comparator is fully migrated to ga4
                    isComparatorView ? track(ChildcareServiceBlock_objectSpread(ChildcareServiceBlock_objectSpread({}, TRACK_ACTION_CART_ADD), {}, {
                      labelGA: constants["f" /* CHILDCARE_TRACKING */].ADD_CHILDCARE
                    })) : trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_UPSELL, {
                      detail_click: constants["f" /* CHILDCARE_TRACKING */].ADD_CHILDCARE
                    });
                    setChildcareMorningAfternoonExclusiveRBOpen();

                  case 8:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          function onClick() {
            return _onClick.apply(this, arguments);
          }

          return onClick;
        }()
      }, type === 'full' && {
        label: Object(i18n["h" /* t */])('booking.services.childcare.childcareFull')
      }), {}, {
        onClose: setChildcareMorningAfternoonExclusiveRBClosed,
        isLoading: isLoading
      });
    }

    if (onCtaClick) {
      return ChildcareServiceBlock_objectSpread({
        dataCsOverrideId: dataCsOverrideId,
        onClick: function () {
          var _onClick2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
            return regenerator_default.a.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    setIsLoading(true);
                    _context2.next = 3;
                    return onCtaClick();

                  case 3:
                    setIsLoading(false);

                  case 4:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          function onClick() {
            return _onClick2.apply(this, arguments);
          }

          return onClick;
        }()
      }, type === 'full' && {
        label: Object(i18n["h" /* t */])('booking.services.childcare.childcareFull')
      });
    }
  };

  var buttonCfg = onClickChildcareButton();

  var onSubmit = /*#__PURE__*/function () {
    var _ref7 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee3(updatedService, serviceIds, attendeeIds) {
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setIsLoading(true);
              _context3.prev = 1;
              _context3.next = 4;
              return updateService(updatedService, childcare.pricingInfo, serviceIds, attendeeIds);

            case 4:
              _context3.next = 9;
              break;

            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3["catch"](1);
              logger["default"].error(_context3.t0);

            case 9:
              _context3.prev = 9;
              setIsLoading(false);
              return _context3.finish(9);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 6, 9, 12]]);
    }));

    return function onSubmit(_x, _x2, _x3) {
      return _ref7.apply(this, arguments);
    };
  }();

  var openingHoursLabels = ChildcareServiceBlock_jsx(childcare_utils["a" /* DurationSlotsLabels */], {
    timeSlots: childcare.productInfo.timeSlots || [],
    closingWeekdays: childcare.productInfo.closingWeekdays || [] || [],
    isPetitCM: Object(childcare_utils["e" /* isPetitClubMed */])(childcare)
  });

  return ChildcareServiceBlock_jsx("div", {
    className: className,
    "data-testid": dataTestId
  }, ChildcareServiceBlock_jsx("p", {
    className: "text-16",
    "data-testid": "ChildcareServiceBlock-childBirthdateMessage",
    style: {
      minHeight: blockMinHeight
    }
  }, childBirthdateMessage), ChildcareServiceBlock_jsx(ServiceBlock_ServiceBlock, {
    addLabel: Object(i18n["h" /* t */])('booking.services.childcare.addChildcare'),
    attendeeId: childId,
    showOnlyCurrentAttendeeSlots: true,
    button: buttonCfg,
    dataSelector: "Childcare",
    equipment: {
      id: childcare.pricingInfo.id,
      label: childcare.productInfo.label,
      longDescription: childcare.productInfo.description
    },
    header: {
      color: isIncluded ? '#1E2643' : '#924833',
      header: 'large',
      icon: isIncluded ? icons["a" /* ICONS */].ALL_INCLUSIVE : icons["a" /* ICONS */].ON_DEMAND,
      label: isIncluded ? Object(i18n["h" /* t */])('booking.childcarePopIn.includedChildcare') : Object(i18n["h" /* t */])('booking.childcarePopIn.onDemandChildcare')
    },
    image: childcare.productInfo.images[0],
    includedLabel: Object(i18n["h" /* t */])('common.included'),
    intro: !isIncluded ? Object(i18n["h" /* t */])('booking.services.childcare.babyClubMedReassurance') : undefined,
    isValidated: ['disabled', 'remove', 'full', 'none'].includes(type),
    lastAvailabilities: ChildcareServiceBlock_jsx(ChildcareServiceBlock_LastAvailabilitiesTag, {
      childcare: childcare,
      type: type
    }),
    price: (_childcare$pricingInf2 = childcare.pricingInfo) === null || _childcare$pricingInf2 === void 0 ? void 0 : (_childcare$pricingInf3 = _childcare$pricingInf2.startingPricePerAdult) === null || _childcare$pricingInf3 === void 0 ? void 0 : _childcare$pricingInf3.formattedValue,
    rentedAmount: (_childcare$pricingInf4 = childcare.pricingInfo) === null || _childcare$pricingInf4 === void 0 ? void 0 : (_childcare$pricingInf5 = _childcare$pricingInf4.attendees) === null || _childcare$pricingInf5 === void 0 ? void 0 : (_childcare$pricingInf6 = _childcare$pricingInf5.find(function (_ref8) {
      var id = _ref8.id;
      return id === childId;
    })) === null || _childcare$pricingInf6 === void 0 ? void 0 : _childcare$pricingInf6.rentedAmount.formattedValue,
    removeLabel: Object(i18n["h" /* t */])('booking.services.childcare.removeChildcare'),
    slots: [{
      disclaimer: Object(i18n["h" /* t */])('booking.services.childcare.openingDisclaimer'),
      icon: icons["a" /* ICONS */].DURATION,
      label: openingHoursLabels,
      key: 'duration-description'
    }, {
      icon: icons["a" /* ICONS */].DATE_STAR,
      label: Object(product_utils["f" /* getServiceAgesLabel */])(childcare.productInfo.ageInMonths),
      key: 'date-star'
    }].filter(function (slot) {
      return slot.label;
    }),
    type: type,
    urgentisation: childcare.productInfo.isIncluded || childcare.pricingInfo.isFullyPaid ? undefined : ChildcareServiceBlock_jsx(UrgentisationChildcareBlock_UrgentisationChildcareBlock, {
      childcare: childcare,
      type: type,
      isByDayChildcare: shouldTriggerChildcareAdvancedReservationBlockOnClick,
      isFullStayHalfDayChildcare: shouldTriggerChildcareMorningAfternoonExclusiveBlockOnClick
    })
  }), ChildcareServiceBlock_jsx("div", null, childcare && isChildcareAdvancedReservationBlockOpen && ChildcareServiceBlock_jsx(PopInReservationBlock["a" /* PopInReservationBlock */], {
    attendeeId: childId,
    showOnlyCurrentAttendeeSlots: true,
    headerLabel: (_childcare$productInf = childcare.productInfo) === null || _childcare$productInf === void 0 ? void 0 : _childcare$productInf.label,
    introductionLabel: Object(i18n["h" /* t */])('booking.activities.childcare.chooseWhen'),
    onClose: setChildcareBlockAdvancedClosed,
    onSubmit: onSubmit,
    rentButtonLabel: Object(i18n["h" /* t */])('booking.common.addPrice'),
    service: childcare.pricingInfo
  })), ChildcareServiceBlock_jsx("div", null, childcare && isChildcareMorningAfternoonExclusiveRBOpen && ChildcareServiceBlock_jsx(PopInReservationBlockMorningAfternoonExclusive["a" /* PopInReservationBlockMorningAfternoonExclusive */], {
    slots: childcare.pricingInfo.schedules[0].slots,
    headerLabel: (_childcare$productInf2 = childcare.productInfo) === null || _childcare$productInf2 === void 0 ? void 0 : _childcare$productInf2.label,
    onClose: setChildcareMorningAfternoonExclusiveRBClosed,
    service: childcare.pricingInfo
  })));
};
// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/widgets/childcare/childcare.helper.js
var childcare_helper = __webpack_require__("YVWi");

// CONCATENATED MODULE: ./src/client/components/widgets/childcare/Childcare.jsx













var Childcare_jsx = react_default.a.createElement;

function Childcare_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Childcare_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Childcare_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Childcare_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















var Childcare_getBlockMinHeight = function getBlockMinHeight(wrapper) {
  if (!wrapper) {
    return 0;
  }

  var nodeHeightsList = Object(toConsumableArray["a" /* default */])(wrapper.querySelectorAll('[data-testid="ChildcareServiceBlock-childBirthdateMessage"]')).map(function (node) {
    return node.clientHeight || 0;
  });

  return Math.max.apply(Math, Object(toConsumableArray["a" /* default */])(nodeHeightsList));
};

var Childcare_handleClick = function handleClick(_ref) {
  var _childcare$pricingInf, _childcare$pricingInf2, _childcare$pricingInf5;

  var proposals = _ref.proposals,
      childcare = _ref.childcare,
      addChildcare = _ref.addChildcare,
      deleteChildcare = _ref.deleteChildcare,
      trackClickEvent = _ref.trackClickEvent,
      ga3Track = _ref.ga3Track,
      isComparatorView = _ref.isComparatorView;
  // this triggers only when there is only one schedule and one slot
  // if looking for advanced cases check the contextchildcare
  var overloadChildcareIdForChalet = proposals && Object(childcare_helper["e" /* getOverloadChildcareDataForChalet */])({
    proposals: proposals,
    currentChildcareId: childcare.pricingInfo.schedules[0].slots[0].id,
    currentChildId: childcare.pricingInfo.childId || ''
  });
  var currentAttendeeHasRentedChildcare = ((_childcare$pricingInf = childcare.pricingInfo.attendees.find(function (_ref2) {
    var _childcare$pricingInf3;

    var id = _ref2.id;
    return id === ((_childcare$pricingInf3 = childcare.pricingInfo) === null || _childcare$pricingInf3 === void 0 ? void 0 : _childcare$pricingInf3.childId);
  } // $FlowFixMe : always int and found
  )) === null || _childcare$pricingInf === void 0 ? void 0 : (_childcare$pricingInf2 = _childcare$pricingInf.rentedAmount) === null || _childcare$pricingInf2 === void 0 ? void 0 : _childcare$pricingInf2.value) > 0;

  if (currentAttendeeHasRentedChildcare) {
    var _childcare$pricingInf4;

    isComparatorView ? ga3Track(Childcare_objectSpread(Childcare_objectSpread({}, TRACK_ACTION_CART_REMOVE), {}, {
      labelGA: constants["f" /* CHILDCARE_TRACKING */].REMOVE_CHILDCARE
    })) : trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_UPSELL, {
      detail_click: constants["f" /* CHILDCARE_TRACKING */].REMOVE_CHILDCARE
    });
    return deleteChildcare({
      childcareId: childcare.pricingInfo.progId || '',
      attendeeId: ((_childcare$pricingInf4 = childcare.pricingInfo) === null || _childcare$pricingInf4 === void 0 ? void 0 : _childcare$pricingInf4.childId) || '',
      startDate: childcare.pricingInfo.schedules[0].startDate,
      endDate: childcare.pricingInfo.schedules[0].startDate,
      overloadChildcareIdForChalet: overloadChildcareIdForChalet
    });
  }

  isComparatorView ? ga3Track(Childcare_objectSpread(Childcare_objectSpread({}, TRACK_ACTION_CART_ADD), {}, {
    labelGA: constants["f" /* CHILDCARE_TRACKING */].ADD_CHILDCARE
  })) : trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_UPSELL, {
    detail_click: constants["f" /* CHILDCARE_TRACKING */].ADD_CHILDCARE
  }); // Those are regular childcares only one schedule and no slots

  return addChildcare({
    childcareId: childcare.pricingInfo.progId || '',
    attendeeId: ((_childcare$pricingInf5 = childcare.pricingInfo) === null || _childcare$pricingInf5 === void 0 ? void 0 : _childcare$pricingInf5.childId) || '',
    startDate: childcare.pricingInfo.schedules[0].startDate,
    endDate: childcare.pricingInfo.schedules[0].endDate,
    overloadChildcareIdForChalet: overloadChildcareIdForChalet
  });
};

var Childcare_Childcare = function Childcare(_ref3) {
  var addChildcare = _ref3.addChildcare,
      attendees = _ref3.attendees,
      childcareAdditionalServices = _ref3.childcareAdditionalServices,
      deleteChildcare = _ref3.deleteChildcare,
      isCondensed = _ref3.isCondensed,
      proposals = _ref3.proposals,
      _ref3$shouldTrack = _ref3.shouldTrack,
      shouldTrack = _ref3$shouldTrack === void 0 ? true : _ref3$shouldTrack;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var includedBlocks = Object(react["useRef"])();
  var notIncludedBlocks = Object(react["useRef"])();

  var _useState = Object(react["useState"])(0),
      includedMinHeight = _useState[0],
      setIncludedMinHeight = _useState[1];

  var _useState2 = Object(react["useState"])(0),
      notIncludedMinHeight = _useState2[0],
      setNotIncludedMinHeight = _useState2[1];

  var router = Object(next_router["useRouter"])();

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var ga3Track = Object(useTracking["a" /* useTracking */])();
  var isComparatorView = router.pathname === '/comparator';
  Object(react["useEffect"])(function () {
    setIncludedMinHeight(Childcare_getBlockMinHeight(includedBlocks.current));
    setNotIncludedMinHeight(Childcare_getBlockMinHeight(notIncludedBlocks.current));
  });

  var _includedAndNotInclud = Object(childcare_helper["g" /* includedAndNotIncludedChildcares */])(childcareAdditionalServices),
      includedChildcares = _includedAndNotInclud.includedChildcares,
      notIncludedChildcares = _includedAndNotInclud.notIncludedChildcares;

  if (attendees.length === 0) {
    return null;
  }

  var getChildBirthDateMessage = function getChildBirthDateMessage(childAttendeeId) {
    if (!childAttendeeId) {
      return '';
    }

    var currentKid = Object(childcare_helper["b" /* getCurrentChild */])(attendees, childAttendeeId);

    if (currentKid && currentKid.firstName && currentKid.lastName) {
      return Object(i18n["h" /* t */])('booking.services.childcare.firstnameLastnameBornOn', {
        lastName: currentKid.lastName,
        firstName: currentKid.firstName,
        birthdate: Object(childcare_helper["d" /* getFormatDate */])(currentKid, Object(i18n["h" /* t */])('common.dateFormatTechnicalID'))
      });
    }

    return Object(i18n["h" /* t */])('booking.services.childcare.forWhatKid', {
      birthdate: Object(childcare_helper["d" /* getFormatDate */])(currentKid, Object(i18n["h" /* t */])('common.dateFormatTechnicalID'))
    });
  };

  return Childcare_jsx("div", {
    "data-testid": "PackageChildcare"
  }, childcareAdditionalServices.length === 0 ? Childcare_jsx(Notification["a" /* Notification */], {
    className: "text-orange",
    text: Object(i18n["h" /* t */])('booking.form.warnings.noChildcareMessage')
  }) : Childcare_jsx("div", null, Childcare_jsx(Title["a" /* Title */], {
    className: "mb-10 w-full md:whitespace-nowrap",
    theme: "title-brand-n2"
  }, Object(i18n["h" /* t */])('booking.services.childcare.childcareTitle', {
    number: childcareAdditionalServices.length
  })), !!notIncludedChildcares.length && Childcare_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('-mx-10 flex flex-wrap', {
      'mb-20': !isDesktop,
      'mb-80': isDesktop
    }),
    ref: notIncludedBlocks
  }, notIncludedChildcares.sort(function (childcareEl, nextChildcareEl) {
    var _childcareEl$pricingI, _nextChildcareEl$pric;

    return (// $FlowFixMe : always found
      ((_childcareEl$pricingI = childcareEl.pricingInfo) === null || _childcareEl$pricingI === void 0 ? void 0 : _childcareEl$pricingI.childId) > ((_nextChildcareEl$pric = nextChildcareEl.pricingInfo) === null || _nextChildcareEl$pric === void 0 ? void 0 : _nextChildcareEl$pric.childId)
    );
  }).map(function (childcare, index) {
    var _childcare$pricingInf6, _childcare$pricingInf7, _childcare$pricingInf8;

    var childId = childcare.pricingInfo.childId;
    var childcareCta = Object(childcare_helper["a" /* getCtaTypeChildcare */])(childcare);
    var shouldTriggerChildcareAdvancedReservationBlockOnClick = ((_childcare$pricingInf6 = childcare.pricingInfo.schedules) === null || _childcare$pricingInf6 === void 0 ? void 0 : _childcare$pricingInf6.length) > 1;
    var shouldTriggerChildcareMorningAfternoonExclusiveBlockOnClick = ((_childcare$pricingInf7 = childcare.pricingInfo.schedules) === null || _childcare$pricingInf7 === void 0 ? void 0 : _childcare$pricingInf7.length) === 1 && ((_childcare$pricingInf8 = childcare.pricingInfo.schedules[0].slots) === null || _childcare$pricingInf8 === void 0 ? void 0 : _childcare$pricingInf8.length) >= 1 && childcare.pricingInfo.schedules[0].slots.length <= 3 && childcare.pricingInfo.schedules[0].slots.some(function (_ref4) {
      var type = _ref4.type;
      return type === 'MORNING' || type === 'AFTERNOON';
    }); // one schedule on slot ( the classic case )

    var isSimpleChildcare = !shouldTriggerChildcareAdvancedReservationBlockOnClick && !shouldTriggerChildcareMorningAfternoonExclusiveBlockOnClick;
    return Childcare_jsx(ChildcareServiceBlock_ChildcareServiceBlock, {
      blockMinHeight: notIncludedMinHeight,
      childId: childId,
      childBirthdateMessage: getChildBirthDateMessage(childId),
      childcare: childcare,
      className: Object(classnames_utils["a" /* classnames */])('w-full p-10', {
        'sm:w-1/2 md:w-1/3': !isCondensed
      }),
      dataCsOverrideId: "Childcare-".concat(index),
      dataTestId: "childcare-block",
      isIncluded: false,
      key: childId,
      onCtaClick: function onCtaClick() {
        return Childcare_handleClick({
          proposals: proposals,
          childcare: childcare,
          addChildcare: addChildcare,
          deleteChildcare: deleteChildcare,
          trackClickEvent: trackClickEvent,
          isComparatorView: isComparatorView,
          ga3Track: ga3Track
        });
      },
      shouldTriggerChildcareAdvancedReservationBlockOnClick: shouldTriggerChildcareAdvancedReservationBlockOnClick,
      shouldTriggerChildcareMorningAfternoonExclusiveBlockOnClick: shouldTriggerChildcareMorningAfternoonExclusiveBlockOnClick,
      shouldTrack: shouldTrack && isSimpleChildcare,
      trackingType: childcareCta.tracking,
      type: childcareCta.type
    });
  })), !!includedChildcares.length && Childcare_jsx("div", {
    className: "-mx-10 flex flex-wrap",
    ref: includedBlocks
  }, includedChildcares.map(function (childcare, index) {
    return Childcare_jsx(ChildcareServiceBlock_ChildcareServiceBlock, {
      blockMinHeight: includedMinHeight,
      childBirthdateMessage: getChildBirthDateMessage(childcare.pricingInfo.childId),
      childcare: childcare,
      childId: childcare.pricingInfo.childId,
      className: Object(classnames_utils["a" /* classnames */])('w-full p-10', {
        'sm:w-1/2 md:w-1/3': !isCondensed
      }),
      dataCsOverrideId: "Childcare-".concat(index),
      dataTestId: "childcare-block",
      isIncluded: true,
      key: childcare.pricingInfo.childId,
      shouldTrack: shouldTrack,
      type: "disabled"
    });
  }))));
};

/***/ }),

/***/ "LoHR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChildcareOnDemandEquipmentCapsule; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_product_product_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("C9cF");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_capsule_Capsule__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("jldR");
/* harmony import */ var _frameworks_collapse_panel_CollapsePanel__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("gA51");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("qBqs");



var __jsx = react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement;







var EQUIPMENT_ID_MAPPING = {
  ACT_CANC_CHILD_baby_sitting: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].BABYSITTING,
  ACT_CANC_CHILD_pyjamas_club: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].PAJAMAS,
  ACT_CANC_CHILD_teen_spa: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].SPA,
  ACT_CANC_CHILD_swimming_lessons: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].SWIMMINGPOOL,
  ACT_CANC_CHILD_pleasures_of_snow_course: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].SKI
};
var ChildcareOnDemandEquipmentCapsule = function ChildcareOnDemandEquipmentCapsule(_ref) {
  var activities = _ref.activities,
      isSeller = _ref.isSeller;
  return __jsx(_frameworks_capsule_Capsule__WEBPACK_IMPORTED_MODULE_7__[/* Capsule */ "a"], {
    className: "mb-100",
    color: "#924833",
    header: "large",
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "h"])('booking.childcarePopIn.onDemandChildcare')
  }, __jsx("p", {
    className: "p-20 text-14 font-bold"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "h"])(isSeller ? 'booking.partners.services.childcare.additionalServicesReassuranceMessage' : 'booking.services.childcare.additionalServicesReassuranceMessage')), activities.map(function (activity) {
    return __jsx("div", {
      className: "border-t-1 border-lightGrey font-bold",
      key: activity.id
    }, __jsx(_frameworks_collapse_panel_CollapsePanel__WEBPACK_IMPORTED_MODULE_8__[/* CollapsePanel */ "a"], {
      collapseIconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].ARROW_DOWN,
      expandIconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].ARROW_DOWN,
      theme: "limpidSmall",
      title: __jsx("span", {
        className: "flex items-center gap-15 text-14 font-bold text-sienna"
      }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_9__[/* Icon */ "a"], {
        className: "shrink-0",
        name: EQUIPMENT_ID_MAPPING[activity.id] || _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].TRIDENT1,
        width: "1.875rem"
      }), __jsx("span", null, activity.label, !!activity.ageInMonths && __jsx("span", {
        className: "block text-12 font-normal text-black"
      }, Object(_utils_product_product_utils__WEBPACK_IMPORTED_MODULE_5__[/* getServiceAgesLabel */ "f"])(activity.ageInMonths))))
    }, __jsx("p", {
      className: "p-20 pt-0 text-14 font-normal leading-tight"
    }, activity.description)));
  }));
};

/***/ }),

/***/ "OTqw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RentalsBooking; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _rentals_Rentals__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("3AZ6");
/* harmony import */ var _context_ServicesContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("2Odu");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;



var RentalsBooking = function RentalsBooking(_ref) {
  var contextValue = _ref.contextValue,
      rentals = _ref.rentals,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["contextValue", "rentals"]);

  return __jsx(_context_ServicesContext__WEBPACK_IMPORTED_MODULE_4__[/* ServicesContext */ "a"].Provider, {
    value: contextValue
  }, __jsx(_rentals_Rentals__WEBPACK_IMPORTED_MODULE_3__[/* Rentals */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, rest, {
    rentalsTree: rentals
  })));
};

/***/ }),

/***/ "UnYQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChildcareIncludedEquipmentCapsule; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("vfdX");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("hCOa");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("lTEL");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("m9LP");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("87if");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("kYxP");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_capsule_collapse_lists_CapsuleCollapseLists__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("d4In");















var __jsx = react__WEBPACK_IMPORTED_MODULE_15___default.a.createElement;




var ChildcareIncludedEquipmentCapsule = function ChildcareIncludedEquipmentCapsule(_ref) {
  var className = _ref.className,
      facilities = _ref.facilities;
  var deduplicatedLists = Object(react__WEBPACK_IMPORTED_MODULE_15__["useMemo"])(function () {
    if (!facilities || facilities.length === 0) {
      return [];
    } // Group facilities by subtitle (merge facilities with the same subtitle)


    var groupedBySubtitle = facilities.reduce(function (acc, facility) {
      var subtitle = facility.subtitle || '';
      var title = facility.subtitle || facility.label || '';

      if (!acc[subtitle]) {
        acc[subtitle] = {
          title: title,
          equipments: new Map()
        };
      } // Merge equipments from facilities with same subtitle


      (facility.equipments || []).forEach(function (equipment) {
        if (equipment.id && !acc[subtitle].equipments.has(equipment.id)) {
          acc[subtitle].equipments.set(equipment.id, equipment);
        }
      });
      return acc;
    }, {}); // track which equipment appears in which facilities (by subtitle)

    var equipmentToFacilities = new Map();
    Object.keys(groupedBySubtitle).forEach(function (subtitle) {
      var group = groupedBySubtitle[subtitle];
      group.equipments.forEach(function (equipment) {
        if (!equipmentToFacilities.has(equipment.id)) {
          equipmentToFacilities.set(equipment.id, []);
        }

        var facilityList = equipmentToFacilities.get(equipment.id);

        if (facilityList) {
          facilityList.push(subtitle);
        }
      });
    }); // For each facility group, remove equipments that appear in other facilities
    // Keep equipment only in the first facility where it appears

    var facilityOrder = Object.keys(groupedBySubtitle);
    var processedLists = facilityOrder.map(function (subtitle, index) {
      var group = groupedBySubtitle[subtitle];
      var filteredEquipments = Array.from(group.equipments.values()).filter(function (equipment) {
        var facilitiesWithEquipment = equipmentToFacilities.get(equipment.id) || []; // If equipment appears in only one facility, keep it

        if (facilitiesWithEquipment.length === 1) {
          return true;
        } // If equipment appears in multiple facilities, keep it only in the first one


        var firstFacilityIndex = facilityOrder.findIndex(function (key) {
          return facilitiesWithEquipment.includes(key);
        });
        return firstFacilityIndex === index;
      });
      return {
        title: group.title,
        items: filteredEquipments.map(function (equipment) {
          return {
            iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_16__[/* ICONS */ "a"][equipment.id],
            label: equipment.label
          };
        })
      };
    });
    return processedLists;
  }, [facilities]);
  return __jsx(_frameworks_capsule_collapse_lists_CapsuleCollapseLists__WEBPACK_IMPORTED_MODULE_18__[/* CapsuleCollapseLists */ "a"], {
    className: className,
    header: {
      iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_16__[/* ICONS */ "a"].ALL_INCLUSIVE,
      title: Object(_i18n__WEBPACK_IMPORTED_MODULE_17__[/* t */ "h"])('common.allInclusive')
    },
    lists: deduplicatedLists
  });
};

/***/ }),

/***/ "V+KB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useChidcareContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useChildcareContextPLE; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("JtPf");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_promise_finally__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Qavd");
/* harmony import */ var core_js_modules_es_promise_finally__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_finally__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("uDfI");
/* harmony import */ var _client_store_booking_proposals_proposals_action__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("AnR0");
/* harmony import */ var _client_components_utils_booking_booking_additional_services_BookingAddtionalServices_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("JOeK");
/* harmony import */ var _client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("Ub5k");
/* harmony import */ var _client_components_widgets_cart_cart_actions__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("zhg9");
/* harmony import */ var _client_tracking_tracking_api_useTrackEvent__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("DqI1");
/* harmony import */ var _client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("829J");









/* eslint-disable max-params */








 // COMMON TRACKING
// ON Error add Upsells

var trackErrorUnknownChildcare = function trackErrorUnknownChildcare(trackClickEvent) {
  trackClickEvent(_client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* TRACK_EVENT_NAMES */ "F"].CLICK_ERROR, {
    detail_click: _client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* CHILDCARE_TRACKING */ "f"].ERROR_UNKNOWN_CHILDCARE
  });
}; // advanced by day case


var getDaysOrFullStayLabelGA = function getDaysOrFullStayLabelGA(pricingInfo, attendees) {
  var currentAttendee = attendees.find(function (_ref) {
    var _ref$customerId = _ref.customerId,
        customerId = _ref$customerId === void 0 ? '' : _ref$customerId,
        _ref$id = _ref.id,
        id = _ref$id === void 0 ? '' : _ref$id;
    return customerId === pricingInfo.childId || id === pricingInfo.childId;
  });
  var rentedSchedules = currentAttendee === null || currentAttendee === void 0 ? void 0 : currentAttendee.schedules;
  var rentedSchedulesNumber = (rentedSchedules === null || rentedSchedules === void 0 ? void 0 : rentedSchedules.length) || 0;

  if (rentedSchedules && (rentedSchedules === null || rentedSchedules === void 0 ? void 0 : rentedSchedules.length) > 1 || // $FlowFixMe we verify we have the item first
  rentedSchedulesNumber === 1 && rentedSchedules[0].startDate === rentedSchedules[0].endDate) {
    // here is the case of renting some n days but in the case of childcare by day
    return "dayslot_".concat(rentedSchedulesNumber);
  }

  if (rentedSchedulesNumber === 1 && // $FlowFixMe we verify we have the item first
  rentedSchedules[0].startDate !== rentedSchedules[0].endDate) {
    // here is the case of renting the full stay slot but in the case of childcare by day
    return 'all_journey';
  }
}; // morning afternoon or full day case for all stay case


var getMorningAfternoonOrFullDay = function getMorningAfternoonOrFullDay(pricingInfo, serviceId) {
  var _currentAttendee$sche, _currentAttendee$sche2;

  var currentAttendee = pricingInfo.attendees.find(function (_ref2) {
    var id = _ref2.id,
        _ref2$customerId = _ref2.customerId,
        customerId = _ref2$customerId === void 0 ? '' : _ref2$customerId;
    return id === pricingInfo.childId || customerId === pricingInfo.childId;
  });
  var rentedSlotName = currentAttendee === null || currentAttendee === void 0 ? void 0 : (_currentAttendee$sche = currentAttendee.schedules[0].timeSlots) === null || _currentAttendee$sche === void 0 ? void 0 : (_currentAttendee$sche2 = _currentAttendee$sche.find(function (_ref3) {
    var id = _ref3.id;
    return id === serviceId;
  })) === null || _currentAttendee$sche2 === void 0 ? void 0 : _currentAttendee$sche2.slotName;

  if (rentedSlotName === 'MORNING') {
    return 'morning';
  }

  if (rentedSlotName === 'AFTERNOON') {
    return 'afternoon';
  }

  if (rentedSlotName === 'DAY') {
    return 'all_day';
  }
}; // END COMMON TRACKING

/**
 * BE
 */
// get the childcare s context values for BE


var useChidcareContext = function useChidcareContext(_ref4) {
  var proposals = _ref4.proposals,
      appContext = _ref4.appContext;
  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_10__[/* useDispatch */ "d"])();

  var _useTrackEvent = Object(_client_tracking_tracking_api_useTrackEvent__WEBPACK_IMPORTED_MODULE_15__[/* useTrackEvent */ "a"])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var childcareContextServicesValuesBE = Object(react__WEBPACK_IMPORTED_MODULE_9__["useMemo"])(function () {
    var _proposals$, _proposals$$price;

    return {
      currency: proposals === null || proposals === void 0 ? void 0 : (_proposals$ = proposals[0]) === null || _proposals$ === void 0 ? void 0 : (_proposals$$price = _proposals$.price) === null || _proposals$$price === void 0 ? void 0 : _proposals$$price.currency,
      showRentAllSchedules: true,
      // FULL STAY SCHEDULE OR SINGLE DAY SCHEDULE
      // eslint-disable-next-line
      updateService: function () {
        var _updateService = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee(attendees, pricingInfo, serviceIds, attendeeIds) {
          var daysOrFullStayLabelGA;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (pricingInfo.isPartiallyRented) {
                    attendees.length === 0 && trackClickEvent(_client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* TRACK_EVENT_NAMES */ "F"].CLICK_UPSELL, {
                      detail_click: _client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* CHILDCARE_TRACKING */ "f"].REMOVE_CHILDCARE
                    });
                    dispatch(Object(_client_store_booking_proposals_proposals_action__WEBPACK_IMPORTED_MODULE_11__[/* deleteAdditionalServices */ "g"])({
                      appContext: appContext,
                      attendeeIds: attendeeIds,
                      serviceIds: serviceIds,
                      showNotification: true,
                      proposals: proposals
                    }));
                  }

                  if (!(attendees.length > 0)) {
                    _context.next = 4;
                    break;
                  }

                  daysOrFullStayLabelGA = getDaysOrFullStayLabelGA(pricingInfo, attendees);
                  return _context.abrupt("return", dispatch(Object(_client_store_booking_proposals_proposals_action__WEBPACK_IMPORTED_MODULE_11__[/* addOrReplaceAdditionalServices */ "d"])({
                    appContext: appContext,
                    attendees: attendees,
                    showNotification: true
                  })).then(function () {
                    trackClickEvent(_client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* TRACK_EVENT_NAMES */ "F"].CLICK_UPSELL, {
                      detail_click: _client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* CHILDCARE_TRACKING */ "f"].ADD_CHILDCARE_POPIN,
                      childcare_timeslot: daysOrFullStayLabelGA
                    });
                  })["catch"](function () {
                    return trackErrorUnknownChildcare(trackClickEvent);
                  }));

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function updateService(_x, _x2, _x3, _x4) {
          return _updateService.apply(this, arguments);
        }

        return updateService;
      }(),
      deleteAttendeeChildcare: function () {
        var _deleteAttendeeChildcare = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee2(_ref5) {
          var attendeeId, pricingInfo, servicesIdsToRemove;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  attendeeId = _ref5.attendeeId, pricingInfo = _ref5.pricingInfo;
                  servicesIdsToRemove = pricingInfo.schedules[0].slots.map(function (slot) {
                    return slot.id;
                  }).filter(Boolean);

                  if (!(servicesIdsToRemove.length > 0 && proposals && (proposals === null || proposals === void 0 ? void 0 : proposals.length) > 0)) {
                    _context2.next = 4;
                    break;
                  }

                  return _context2.abrupt("return", dispatch(Object(_client_store_booking_proposals_proposals_action__WEBPACK_IMPORTED_MODULE_11__[/* deleteAdditionalServices */ "g"])({
                    appContext: appContext,
                    attendeeIds: [attendeeId],
                    serviceIds: servicesIdsToRemove,
                    showNotification: true,
                    proposals: proposals
                  })).then(function () {
                    trackClickEvent(_client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* TRACK_EVENT_NAMES */ "F"].CLICK_UPSELL, {
                      detail_click: _client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* CHILDCARE_TRACKING */ "f"].REMOVE_CHILDCARE
                    });
                  }));

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function deleteAttendeeChildcare(_x5) {
          return _deleteAttendeeChildcare.apply(this, arguments);
        }

        return deleteAttendeeChildcare;
      }(),
      addAttendeeChildcare: function addAttendeeChildcare(_ref6) {
        var attendeeId = _ref6.attendeeId,
            pricingInfo = _ref6.pricingInfo,
            serviceId = _ref6.serviceId;
        var schedules = [{
          startDate: pricingInfo.schedules[0].startDate,
          endDate: pricingInfo.schedules[0].endDate
        }];
        return dispatch(Object(_client_store_booking_proposals_proposals_action__WEBPACK_IMPORTED_MODULE_11__[/* addAdditionalService */ "b"])({
          proposalIds: proposals.map(function (_ref7) {
            var id = _ref7.id;
            return id;
          }),
          serviceId: serviceId,
          attendeeIds: [attendeeId],
          schedules: schedules,
          showNotification: true,
          appContext: appContext
        })).then(function () {
          var morningAfternoonOrFullDayLabelGA = getMorningAfternoonOrFullDay(pricingInfo, serviceId);
          trackClickEvent(_client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* TRACK_EVENT_NAMES */ "F"].CLICK_UPSELL, {
            detail_click: _client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* CHILDCARE_TRACKING */ "f"].ADD_CHILDCARE_POPIN,
            childcare_timeslot: morningAfternoonOrFullDayLabelGA
          });
        })["catch"](function () {
          return trackErrorUnknownChildcare(trackClickEvent);
        });
      }
    };
  }, []);
  return {
    childcareContextServicesValuesBE: childcareContextServicesValuesBE
  };
};
/**
 * END BE
 */

/**
 * PLE
 */

var useChildcareContextPLE = function useChildcareContextPLE(_ref8) {
  var cartState = _ref8.cartState,
      stay = _ref8.stay,
      addOrRemoveChildcareCC = _ref8.addOrRemoveChildcareCC,
      cartChildcares = _ref8.cartChildcares;
  var appContext = Object(_client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_13__[/* useAppContext */ "c"])();
  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_10__[/* useDispatch */ "d"])();

  var _useTrackEvent2 = Object(_client_tracking_tracking_api_useTrackEvent__WEBPACK_IMPORTED_MODULE_15__[/* useTrackEvent */ "a"])(),
      trackClickEvent = _useTrackEvent2.trackClickEvent;

  var childcareContextValuesPLE = Object(react__WEBPACK_IMPORTED_MODULE_9__["useMemo"])(function () {
    return {
      // Case update multi-schedule
      updateService: function updateService(updatedService, pricingInfo, serviceIds) {
        var _pricingInfo$attendee, _pricingInfo$attendee2, _pricingInfo$attendee3;

        var alreadyPaidSchedulesNumber = ((_pricingInfo$attendee = pricingInfo.attendees.find(function (_ref9) {
          var id = _ref9.id;
          return id === pricingInfo.childId;
        })) === null || _pricingInfo$attendee === void 0 ? void 0 : (_pricingInfo$attendee2 = _pricingInfo$attendee.schedules) === null || _pricingInfo$attendee2 === void 0 ? void 0 : (_pricingInfo$attendee3 = _pricingInfo$attendee2.filter(function (_ref10) {
          var isPartiallyPaid = _ref10.isPartiallyPaid;
          return isPartiallyPaid;
        })) === null || _pricingInfo$attendee3 === void 0 ? void 0 : _pricingInfo$attendee3.length) || 0;
        var isAdded = updatedService.some(function (customerService) {
          return !!(customerService.schedules.length - alreadyPaidSchedulesNumber) && customerService.customerId === pricingInfo.childId;
        });

        if (isAdded) {
          var daysOrFullStayLabelGA = getDaysOrFullStayLabelGA(pricingInfo, updatedService);
          trackClickEvent(_client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* TRACK_EVENT_NAMES */ "F"].CLICK_UPSELL, {
            detail_click: _client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* CHILDCARE_TRACKING */ "f"].ADD_CHILDCARE_POPIN,
            childcare_timeslot: daysOrFullStayLabelGA
          });
        } else {
          trackClickEvent(_client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* TRACK_EVENT_NAMES */ "F"].CLICK_UPSELL, {
            detail_click: _client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* CHILDCARE_TRACKING */ "f"].REMOVE_CHILDCARE
          });
        } // format the services to the adequat data structure


        var cart = Object(_client_components_utils_booking_booking_additional_services_BookingAddtionalServices_utils__WEBPACK_IMPORTED_MODULE_12__[/* formatServiceToUpdateBookingCart */ "d"])({
          appContext: appContext,
          bookingId: stay.booking.id,
          serviceIds: serviceIds,
          stay: stay,
          type: pricingInfo.type,
          updatedService: Object(_client_components_utils_booking_booking_additional_services_BookingAddtionalServices_utils__WEBPACK_IMPORTED_MODULE_12__[/* excludePaidSlots */ "c"])(updatedService, stay.upsells.childcares)
        });
        return Object(_client_components_widgets_cart_cart_actions__WEBPACK_IMPORTED_MODULE_14__[/* updateBookingCartSequencially */ "d"])(cart, cartState)["finally"](function () {
          return dispatch(Object(_client_components_widgets_cart_cart_actions__WEBPACK_IMPORTED_MODULE_14__[/* fetchBookingsCart */ "b"])(((cartState === null || cartState === void 0 ? void 0 : cartState.cartBookings) || []).map(function (b) {
            return b.bookingId;
          }), appContext));
        });
      },
      // Case delete and add ( different slots and one schedule )
      deleteAttendeeChildcare: function () {
        var _deleteAttendeeChildcare2 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee3(_ref11) {
          var _currentAttendee$sche3, _currentAttendee$sche4;

          var attendeeId, pricingInfo, currentAttendee, currentAttendeeRentedSlotsIds;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  attendeeId = _ref11.attendeeId, pricingInfo = _ref11.pricingInfo;
                  currentAttendee = pricingInfo.attendees.find(function (_ref12) {
                    var id = _ref12.id;
                    return id === attendeeId;
                  }); // $FlowFixMe : always found

                  currentAttendeeRentedSlotsIds = (_currentAttendee$sche3 = currentAttendee.schedules[0].timeSlots) === null || _currentAttendee$sche3 === void 0 ? void 0 : (_currentAttendee$sche4 = _currentAttendee$sche3.filter(function (_ref13) {
                    var isRented = _ref13.isRented,
                        isPaid = _ref13.isPaid;
                    return isRented && !isPaid;
                  })) === null || _currentAttendee$sche4 === void 0 ? void 0 : _currentAttendee$sche4.map(function (_ref14) {
                    var id = _ref14.id;
                    return id;
                  });

                  if ((currentAttendeeRentedSlotsIds === null || currentAttendeeRentedSlotsIds === void 0 ? void 0 : currentAttendeeRentedSlotsIds.length) > 0) {
                    currentAttendeeRentedSlotsIds.map(function (serviceId) {
                      trackClickEvent(_client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* TRACK_EVENT_NAMES */ "F"].CLICK_UPSELL, {
                        detail_click: _client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* CHILDCARE_TRACKING */ "f"].REMOVE_CHILDCARE
                      }); // always deletes because we check if added to cart or not

                      return addOrRemoveChildcareCC({
                        childcareId: serviceId,
                        attendeeId: attendeeId,
                        startDate: pricingInfo.schedules[0].startDate,
                        endDate: pricingInfo.schedules[0].endDate
                      });
                    });
                  }

                case 4:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        function deleteAttendeeChildcare(_x6) {
          return _deleteAttendeeChildcare2.apply(this, arguments);
        }

        return deleteAttendeeChildcare;
      }(),
      addAttendeeChildcare: function () {
        var _addAttendeeChildcare = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee4(_ref15) {
          var attendeeId, pricingInfo, serviceId, morningAfternoonOrFullDayLabelGA;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  attendeeId = _ref15.attendeeId, pricingInfo = _ref15.pricingInfo, serviceId = _ref15.serviceId;
                  morningAfternoonOrFullDayLabelGA = getMorningAfternoonOrFullDay(pricingInfo, serviceId);
                  trackClickEvent(_client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* TRACK_EVENT_NAMES */ "F"].CLICK_UPSELL, {
                    detail_click: _client_tracking_constants__WEBPACK_IMPORTED_MODULE_16__[/* CHILDCARE_TRACKING */ "f"].ADD_CHILDCARE_POPIN,
                    childcare_timeslot: morningAfternoonOrFullDayLabelGA
                  });
                  return _context4.abrupt("return", addOrRemoveChildcareCC({
                    childcareId: serviceId,
                    attendeeId: attendeeId,
                    startDate: pricingInfo.schedules[0].startDate,
                    endDate: pricingInfo.schedules[0].endDate
                  }));

                case 4:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        function addAttendeeChildcare(_x7) {
          return _addAttendeeChildcare.apply(this, arguments);
        }

        return addAttendeeChildcare;
      }()
    };
  }, [cartChildcares]);
  return {
    childcareContextValuesPLE: childcareContextValuesPLE
  };
};
/**
 * END PLE
 */

/***/ }),

/***/ "YVWi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCtaTypeChildcare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return includedAndNotIncludedChildcares; });
/* unused harmony export getFormattedPricePerDay */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hasChildrenAgedXOrLess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentChild; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCurrentKid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getFormatDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getOverloadChildcareDataForChalet; });
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("DfhM");
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("wz9x");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ldK3");










var API_DATE_FORMAT = 'YYYYMMDD';

function getCtaTypeChildcare(childcare) {
  var _childcare$pricingInf, _childcare$pricingInf2, _currentChildInfos$sc;

  var childId = childcare.pricingInfo.childId;
  var currentChildData = (_childcare$pricingInf = childcare.pricingInfo.attendees) === null || _childcare$pricingInf === void 0 ? void 0 : _childcare$pricingInf.find(function (attendee) {
    return attendee.id === childId;
  });
  var currentChildHasRentedChildcare = (currentChildData === null || currentChildData === void 0 ? void 0 : currentChildData.rentedAmount) && currentChildData.rentedAmount.value > 0;

  if (currentChildHasRentedChildcare) {
    return {
      type: 'remove',
      tracking: 'removeFromCart'
    };
  }

  if (childcare.pricingInfo.isFullyPaid) {
    return {
      type: 'none'
    };
  }

  var currentChildInfos = (_childcare$pricingInf2 = childcare.pricingInfo.attendees) === null || _childcare$pricingInf2 === void 0 ? void 0 : _childcare$pricingInf2.find(function (attendee) {
    return attendee.id === childId;
  }); // the mini clubmed is always included

  var isChildcarePetitOrBaby = childcare.productInfo.ageInMonths.min === 4 || 24;
  var allScheduleSlotsAreFullOrPaid = currentChildInfos === null || currentChildInfos === void 0 ? void 0 : (_currentChildInfos$sc = currentChildInfos.schedules) === null || _currentChildInfos$sc === void 0 ? void 0 : _currentChildInfos$sc.every(function (_ref) {
    var timeSlots = _ref.timeSlots;
    return timeSlots.every(function (_ref2) {
      var remainingStock = _ref2.remainingStock,
          isPaid = _ref2.isPaid;
      return remainingStock === 0 || isPaid;
    });
  });
  var childcareIsFull = isChildcarePetitOrBaby && allScheduleSlotsAreFullOrPaid;

  if (childcareIsFull) {
    return {
      type: 'full'
    };
  }

  return {
    type: 'add',
    tracking: 'addToCart'
  };
}

function getFormattedPricePerDay(price, tripDuration, locale) {
  var pricePerDay = price / tripDuration;
  return Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_8__[/* formatAmountForLocale */ "b"])(pricePerDay, locale);
}

function isChildAgedXOrLess(birthdate, targetAge) {
  return moment__WEBPACK_IMPORTED_MODULE_7___default()(birthdate, API_DATE_FORMAT).isAfter(moment__WEBPACK_IMPORTED_MODULE_7___default()().startOf('day').subtract(targetAge, 'years'));
}

function hasChildrenAgedXOrLess(attendees, targetAge) {
  return attendees.filter(function (attendee) {
    return isChildAgedXOrLess(attendee.birthdate, targetAge);
  }).length > 0;
}

function getCurrentChild(items, itemId) {
  return items.find(function (_ref3) {
    var id = _ref3.id;
    return id === itemId;
  });
} // $FlowFixMe Always found


function getCurrentKid(items, currentChild) {
  return items.find(function (item) {
    if (item.id) {
      return Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_9__[/* timestampToApiDate */ "n"])(item.birthdate) === currentChild.birthdate && item.id === currentChild.id;
    }

    if (item.neolid && currentChild.customerId) {
      return Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_9__[/* timestampToApiDate */ "n"])(item.birthdate) === currentChild.birthdate && item.neolid === currentChild.customerId;
    }

    return Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_9__[/* timestampToApiDate */ "n"])(item.birthdate) === currentChild.birthdate;
  });
}

function getFormatDate(item, message) {
  return Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_9__[/* formatApiDate */ "g"])(lodash_get__WEBPACK_IMPORTED_MODULE_6___default()(item, 'birthdate', ''), message);
}

var includedAndNotIncludedChildcares = function includedAndNotIncludedChildcares(childcareList) {
  return childcareList.reduce(function (acc, childcare) {
    if (childcare.productInfo.isIncluded) {
      acc.includedChildcares.push(childcare);
    } else {
      acc.notIncludedChildcares.push(childcare);
    }

    return acc;
  }, {
    includedChildcares: [],
    notIncludedChildcares: []
  });
};

var getOverloadChildcareDataForChalet = function getOverloadChildcareDataForChalet(_ref4) {
  var _proposalsWithDiffere;

  var proposals = _ref4.proposals,
      currentChildcareId = _ref4.currentChildcareId,
      currentChildId = _ref4.currentChildId;

  if (proposals.every(function (_ref5) {
    var additionalServices = _ref5.additionalServices;
    return additionalServices.childcares.some(function (_ref6) {
      var pricingInfo = _ref6.pricingInfo;
      return pricingInfo.schedules.some(function (_ref7) {
        var slots = _ref7.slots;
        var r = slots.some(function (_ref8) {
          var attendees = _ref8.attendees,
              id = _ref8.id;
          return id === currentChildcareId && attendees.some(function (_ref9) {
            var idChild = _ref9.id;
            return idChild === currentChildId;
          });
        });
        return r;
      });
    });
  })) {
    return;
  }

  var proposalsWithDifferentChildcare = proposals.filter(function (_ref10) {
    var additionalServices = _ref10.additionalServices;
    return !additionalServices.childcares.some(function (_ref11) {
      var pricingInfo = _ref11.pricingInfo;
      return pricingInfo.schedules.some(function (_ref12) {
        var slots = _ref12.slots;
        var r = slots.some(function (_ref13) {
          var attendees = _ref13.attendees,
              id = _ref13.id;
          return id === currentChildcareId && attendees.some(function (_ref14) {
            var idChild = _ref14.id;
            return idChild === currentChildId;
          });
        });
        return r;
      });
    });
  });
  var payload = {
    proposalIds: proposalsWithDifferentChildcare.map(function (_ref15) {
      var id = _ref15.id;
      return id;
    }),
    serviceIds: [((_proposalsWithDiffere = proposalsWithDifferentChildcare[0].additionalServices.childcares.find(function (_ref16) {
      var _pricingInfo$attendee;

      var pricingInfo = _ref16.pricingInfo;
      return (_pricingInfo$attendee = pricingInfo.attendees) === null || _pricingInfo$attendee === void 0 ? void 0 : _pricingInfo$attendee.some(function (_ref17) {
        var id = _ref17.id;
        return id === currentChildId;
      });
    } // $FlowFixMe always found
    )) === null || _proposalsWithDiffere === void 0 ? void 0 : _proposalsWithDiffere.pricingInfo.schedules[0].slots[0].id) || '']
  };
  return payload;
};



/***/ }),

/***/ "bn3Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlternativePackageToolTip; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _frameworks_image_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("0IQ5");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qqKu");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;



var AlternativePackageToolTip = function AlternativePackageToolTip(_ref) {
  var bundle = _ref.bundle;
  return __jsx("div", {
    className: "flex-1"
  }, __jsx(_frameworks_image_Image__WEBPACK_IMPORTED_MODULE_3__[/* Image */ "a"], {
    imageUrl: bundle.image,
    ratioKey: "L"
  }), __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_4__[/* Text */ "a"], {
    className: "p-10",
    text: bundle.description
  }));
};

/***/ }),

/***/ "d4In":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ CapsuleCollapseLists_CapsuleCollapseLists; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/capsule/Capsule.jsx + 1 modules
var Capsule = __webpack_require__("jldR");

// EXTERNAL MODULE: ./src/client/components/frameworks/collapse-panel/CollapsePanel.jsx + 1 modules
var CollapsePanel = __webpack_require__("gA51");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// CONCATENATED MODULE: ./src/client/components/frameworks/capsule-collapse-lists/CapsuleCollapseLists.themes.js

var themes = {
  "default": {
    thCapsuleContent: 'divide-y',
    thMessage: 'font-bold p-20 text-14',
    thCollapse: 'border-lightGrey',
    thCollapseTheme: 'limpidSmall',
    thCollapseIconCollapse: icons["a" /* ICONS */].ARROW_DOWN,
    thCollapseIconExpand: icons["a" /* ICONS */].ARROW_DOWN,
    thItems: 'pb-20 text-14',
    thItem: 'flex gap-15 items-center px-20 py-5',
    thItemIcon: 'shrink-0 text-sienna',
    thItemIconWidth: '1.5rem',
    thItemLabel: 'flex-1'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/capsule-collapse-lists/CapsuleCollapseLists.jsx

var __jsx = react_default.a.createElement;





var CapsuleCollapseLists_CapsuleCollapseLists = function CapsuleCollapseLists(_ref) {
  var className = _ref.className,
      _ref$header = _ref.header,
      header = _ref$header === void 0 ? {} : _ref$header,
      _ref$lists = _ref.lists,
      lists = _ref$lists === void 0 ? [] : _ref$lists,
      message = _ref.message,
      style = _ref.style,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  if (!lists || !lists.length) {
    return null;
  }

  var _themes$theme = themes[theme],
      thCapsuleContent = _themes$theme.thCapsuleContent,
      thCollapse = _themes$theme.thCollapse,
      thCollapseIconCollapse = _themes$theme.thCollapseIconCollapse,
      thCollapseIconExpand = _themes$theme.thCollapseIconExpand,
      thCollapseTheme = _themes$theme.thCollapseTheme,
      thItems = _themes$theme.thItems,
      thItem = _themes$theme.thItem,
      thItemIcon = _themes$theme.thItemIcon,
      thItemIconWidth = _themes$theme.thItemIconWidth,
      thItemLabel = _themes$theme.thItemLabel,
      thMessage = _themes$theme.thMessage;
  return __jsx(Capsule["a" /* Capsule */], {
    additionalStyle: {
      root: style
    },
    className: className,
    color: header.color,
    contentClassName: thCapsuleContent,
    header: "large",
    icon: header.iconName,
    label: header.title
  }, !!message && __jsx("p", {
    className: thMessage
  }, message), lists.map(function (el, index) {
    var _el$items;

    return !!((_el$items = el.items) === null || _el$items === void 0 ? void 0 : _el$items.length) && __jsx(CollapsePanel["a" /* CollapsePanel */], {
      className: thCollapse,
      collapseIconName: thCollapseIconCollapse,
      expandIconName: thCollapseIconExpand,
      isExpanded: index === 0,
      key: el.title,
      theme: thCollapseTheme,
      title: el.title
    }, __jsx("ul", {
      className: thItems
    }, el.items.map(function (_ref2) {
      var iconName = _ref2.iconName,
          label = _ref2.label;
      return __jsx("li", {
        className: thItem,
        key: label
      }, __jsx(Icon["a" /* Icon */], {
        className: thItemIcon,
        name: iconName,
        width: thItemIconWidth
      }), __jsx("span", {
        className: thItemLabel
      }, label));
    })));
  }));
};

/***/ }),

/***/ "gA51":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ CollapsePanel_CollapsePanel; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/utils/unique-id/uniqueId.js
var uniqueId = __webpack_require__("m1JM");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/toggler/Toggler.jsx
var Toggler = __webpack_require__("7CPK");

// CONCATENATED MODULE: ./src/client/components/frameworks/collapse-panel/CollapsePanel.themes.js
var themes = {
  "default": function _default() {
    return {
      thRoot: 'animate-fadeIn animation-duration-500',
      thHeader: 'border-b-1 border-lightGrey flex isolate relative',
      thHeaderDecorator: 'absolute arrow-down arrow-large arrow-white arrow-bg arrow-bg-large arrow-bg-sienna border-b-2 border-sienna -mb-1 opacity-0 bottom-0 start-0 w-full sm:w-1/5 sm:ms-25 transition-opacity duration-250 ease-in z-1',
      thHeaderDecoratorActive: 'opacity-100',
      thButton: 'flex items-center flex-1 max-w-full overflow-hidden py-20 text-initial text-black hocus:text-black-active transition-color',
      thTitle: 'flex-1 flex gap-10 items-center font-bold font-sans leading-tight max-w-full text-current text-20',
      thTitleHasEllipsis: true,
      thTitleIcon: 'text-sienna',
      thLabels: 'shrink-0 font-bold flex items-center text-14 text-sienna uppercase whitespace-nowrap',
      thLabel: 'hidden sm:inline-block',
      thLabelIcon: 'text-black transition-transform duration-250 ease-in ms-10',
      thLabelIconActive: 'transform rotate-180',
      thLabelIconWidth: '0.8125rem',
      thBody: 'overflow-hidden',
      thContent: 'overflow-hidden shadow-inner-bottom',
      thContentInner: 'py-40'
    };
  },
  limpidSmall: function limpidSmall() {
    return {
      thRoot: 'animate-fadeIn animation-duration-500',
      thHeader: 'flex relative text-14',
      thButton: 'flex items-center flex-1 max-w-full overflow-hidden p-20 text-initial text-black',
      thTitle: 'flex flex-1 gap-5 items-center font-bold max-w-full',
      thTitleHasEllipsis: false,
      thLabels: 'shrink-0 font-bold flex items-center ms-auto text-sienna uppercase whitespace-nowrap',
      thLabel: 'underline',
      thLabelIcon: 'text-black ms-10',
      thLabelIconActive: 'transform rotate-180',
      thLabelIconWidth: '0.625rem',
      thBody: 'overflow-hidden',
      thContent: 'overflow-hidden'
    };
  },
  homeDetails: function homeDetails() {
    return {
      thRoot: 'animate-fadeIn animation-duration-500',
      thHeader: 'flex relative',
      thButton: 'flex items-center flex-1 max-w-full overflow-hidden text-initial text-black',
      thTitle: 'flex flex-1 gap-5 items-center max-w-full text-14 font-bold',
      thTitleHasEllipsis: false,
      thTitleIcon: 'text-sienna',
      thLabels: 'shrink-0 font-bold flex items-center ms-auto text-14 text-sienna uppercase whitespace-nowrap',
      thLabel: 'underline',
      thLabelIcon: 'text-black ms-10',
      thLabelIconActive: 'transform rotate-180',
      thLabelIconWidth: '0.75rem',
      thBody: 'overflow-hidden',
      thContent: 'overflow-hidden'
    };
  },
  remote: function remote() {
    return {
      thRoot: 'animate-fadeIn animation-duration-500 bg-white border-1 border-lightGrey rounded-12 shadow-diffuse',
      thHeader: 'flex isolate relative',
      thButton: 'flex flex-1 items-center max-w-full overflow-hidden p-15 text-initial text-black',
      thTitle: 'flex flex-1 font-semibold gap-10 items-center max-w-full',
      thTitleIcon: 'text-sienna',
      thTitleIconSize: '1.875rem',
      thLabels: 'flex items-center ms-auto shrink-0 text-14 text-black whitespace-nowrap',
      thLabelIcon: 'ms-10 text-black',
      thLabelIconActive: 'transform rotate-180',
      thLabelIconWidth: '0.625rem',
      thBody: 'overflow-hidden',
      thContent: 'overflow-hidden',
      thInner: 'w-full'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/collapse-panel/CollapsePanel.jsx










var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var POSITIONS = {
  BOTTOM: 'bottom',
  TOP: 'top'
};

var hasLabels = function hasLabels(_ref, isActive) {
  var collapseIconName = _ref.collapseIconName,
      collapseLabel = _ref.collapseLabel,
      expandIconName = _ref.expandIconName,
      expandLabel = _ref.expandLabel;
  return isActive ? collapseIconName || collapseLabel : expandIconName || expandLabel;
};

var CollapsePanel_LoadMoreButton = function LoadMoreButton(_ref2) {
  var ariaId = _ref2.ariaId,
      isActive = _ref2.isActive,
      isDesktop = _ref2.isDesktop,
      toggle = _ref2.toggle,
      collapsePanelProps = Object(objectWithoutProperties["a" /* default */])(_ref2, ["ariaId", "isActive", "isDesktop", "toggle"]);

  var _collapsePanelProps$a = collapsePanelProps.as,
      HeaderTag = _collapsePanelProps$a === void 0 ? 'div' : _collapsePanelProps$a,
      collapseLabel = collapsePanelProps.collapseLabel,
      _collapsePanelProps$c = collapsePanelProps.collapseIconName,
      collapseIconName = _collapsePanelProps$c === void 0 ? icons["a" /* ICONS */].CROSS : _collapsePanelProps$c,
      expandLabel = collapsePanelProps.expandLabel,
      _collapsePanelProps$e = collapsePanelProps.expandIconName,
      expandIconName = _collapsePanelProps$e === void 0 ? icons["a" /* ICONS */].ARROW_DOWN : _collapsePanelProps$e,
      _collapsePanelProps$h = collapsePanelProps.headerClassName,
      headerClassName = _collapsePanelProps$h === void 0 ? '' : _collapsePanelProps$h,
      iconName = collapsePanelProps.iconName,
      iconSize = collapsePanelProps.iconSize,
      noIcons = collapsePanelProps.noIcons,
      _collapsePanelProps$t = collapsePanelProps.theme,
      theme = _collapsePanelProps$t === void 0 ? 'default' : _collapsePanelProps$t,
      title = collapsePanelProps.title;

  var _themes$theme = themes[theme]({
    isDesktop: isDesktop
  }),
      thButton = _themes$theme.thButton,
      thHeader = _themes$theme.thHeader,
      thHeaderDecorator = _themes$theme.thHeaderDecorator,
      thHeaderDecoratorActive = _themes$theme.thHeaderDecoratorActive,
      thLabels = _themes$theme.thLabels,
      thLabel = _themes$theme.thLabel,
      thLabelIcon = _themes$theme.thLabelIcon,
      thLabelIconActive = _themes$theme.thLabelIconActive,
      thLabelIconWidth = _themes$theme.thLabelIconWidth,
      thTitle = _themes$theme.thTitle,
      thTitleHasEllipsis = _themes$theme.thTitleHasEllipsis,
      thTitleIcon = _themes$theme.thTitleIcon,
      thTitleIconSize = _themes$theme.thTitleIconSize;

  return __jsx(HeaderTag, {
    className: Object(classnames_utils["a" /* classnames */])(headerClassName, thHeader)
  }, __jsx("button", {
    "aria-controls": ariaId,
    "aria-expanded": isActive,
    className: thButton,
    onClick: toggle,
    type: "button"
  }, !!title && __jsx("span", {
    className: thTitle
  }, __jsx(Icon["a" /* Icon */], {
    className: Object(classnames_utils["a" /* classnames */])('shrink-0', thTitleIcon),
    name: iconName,
    width: iconSize || thTitleIconSize || '1em'
  }), thTitleHasEllipsis ? __jsx("span", {
    className: "w-full truncate"
  }, title) : title), hasLabels(collapsePanelProps, isActive) && __jsx("span", {
    className: thLabels
  }, __jsx("span", {
    className: thLabel,
    "data-testid": "CollapsePanel-label"
  }, isActive ? collapseLabel : expandLabel), !noIcons && __jsx(Icon["a" /* Icon */], {
    className: Object(classnames_utils["a" /* classnames */])(thLabelIcon, Object(defineProperty["a" /* default */])({}, thLabelIconActive, isActive)),
    name: isActive ? collapseIconName : expandIconName,
    width: thLabelIconWidth
  }))), (thHeaderDecorator || thHeaderDecoratorActive) && __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thHeaderDecorator, Object(defineProperty["a" /* default */])({}, thHeaderDecoratorActive, isActive))
  }));
};

var CollapsePanel_CollapsePanel = function CollapsePanel(props) {
  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var _useState = Object(react["useState"])(props.isExpanded),
      isVisible = _useState[0],
      setVisible = _useState[1];

  if (!react["Children"].count(props.children)) {
    return null;
  }

  var children = props.children,
      className = props.className,
      _props$hasKeepCollaps = props.hasKeepCollapsedContent,
      hasKeepCollapsedContent = _props$hasKeepCollaps === void 0 ? true : _props$hasKeepCollaps,
      id = props.id,
      isExpanded = props.isExpanded,
      isSemiTransparent = props.isSemiTransparent,
      _props$loadMoreButton = props.loadMoreButtonPosition,
      loadMoreButtonPosition = _props$loadMoreButton === void 0 ? POSITIONS.TOP : _props$loadMoreButton,
      onClick = props.onClick,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      title = props.title;

  var _themes$theme2 = themes[theme]({
    isDesktop: isDesktop
  }),
      thBody = _themes$theme2.thBody,
      thCollapsedTagInitialStyle = _themes$theme2.thCollapsedTagInitialStyle,
      thContent = _themes$theme2.thContent,
      thContentInner = _themes$theme2.thContentInner,
      thRoot = _themes$theme2.thRoot;

  var ariaId = Object(uniqueId["b" /* generateUniqueId */])([id || title || ''], 'CollapsePanel_');
  var CollapsedTag = hasKeepCollapsedContent ? lib["Collapse"] : lib["UnmountClosed"];
  return __jsx(Toggler["a" /* Toggler */], {
    isActive: isExpanded,
    onToggle: onClick
  }, function (toggle, isActive) {
    return __jsx("section", {
      className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
      id: id
    }, loadMoreButtonPosition === POSITIONS.TOP && __jsx(CollapsePanel_LoadMoreButton, Object(esm_extends["a" /* default */])({}, props, {
      ariaId: ariaId,
      isActive: isActive,
      isDesktop: isDesktop,
      toggle: toggle
    })), __jsx("div", {
      "aria-hidden": !isActive,
      className: Object(classnames_utils["a" /* classnames */])(thBody, {
        invisible: !isVisible
      }),
      id: ariaId
    }, __jsx(CollapsedTag, {
      initialStyle: isSemiTransparent ? _objectSpread({
        height: 'auto',
        overflow: 'initial'
      }, thCollapsedTagInitialStyle) : thCollapsedTagInitialStyle,
      isOpened: isActive,
      onWork: function onWork() {
        setVisible(true);
      },
      onRest: function onRest(_ref3) {
        var isFullyClosed = _ref3.isFullyClosed;
        setVisible(!isFullyClosed);
      }
    }, __jsx("div", {
      className: thContent
    }, __jsx("div", {
      className: thContentInner
    }, children)))), loadMoreButtonPosition === POSITIONS.BOTTOM && __jsx(CollapsePanel_LoadMoreButton, Object(esm_extends["a" /* default */])({}, props, {
      ariaId: ariaId,
      isActive: isActive,
      isDesktop: isDesktop,
      toggle: toggle
    })));
  });
};

/***/ }),

/***/ "mYZO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TransferBulletPoints; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kiXb");
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _components_frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("VHif");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;




var TransferBulletPoints = function TransferBulletPoints(_ref) {
  var title = _ref.title,
      bulletPoints = _ref.bulletPoints;
  var filteredBulletPoints = bulletPoints.map(function (bulletPoint) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])(bulletPoint);
  }) // this filter is keep only translated bullet points and non null
  .filter(function (bulletPoint, index) {
    return bulletPoint !== bulletPoints[index] && bulletPoint !== '';
  });
  return __jsx("div", {
    "data-testid": "TransferBulletPoints",
    className: "h-full rounded-16 border-1 border-lightGrey bg-white p-20"
  }, __jsx("div", {
    "data-testid": "TransferBulletPoints-icon",
    className: "flex items-start gap-20"
  }, __jsx(_components_frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_5__[/* Badge */ "a"], {
    className: "size-48 border-lightSand bg-lightSand text-black",
    iconName: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].CAR,
    iconSize: "24px",
    variant: "pill"
  }), __jsx("div", {
    className: "text-start text-16 leading-normal"
  }, __jsx("p", {
    className: "mb-8 font-semibold"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])(title)), __jsx("ul", {
    className: "list-none"
  }, filteredBulletPoints === null || filteredBulletPoints === void 0 ? void 0 : filteredBulletPoints.map(function (bulletPointSingleInfo, index) {
    return __jsx("li", {
      className: "list-disc",
      key: "TransferBulletPoints-".concat(index * 1)
    }, bulletPointSingleInfo);
  })))));
};

/***/ }),

/***/ "o8kQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ctaActionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaidService; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("C/y5");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("SPKZ");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("sRdV");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_capsule_Capsule__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("jldR");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_image_Image__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("0IQ5");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("qqKu");
/* harmony import */ var _frameworks_tooltip_Tooltip__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("i3Ve");



var __jsx = react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement;











var ctaActionTypes = {
  add: 'add',
  remove: 'remove',
  disabled: 'disabled',
  included: 'included',
  none: 'none'
};

var AddRemoveButton = function AddRemoveButton(_ref) {
  var isAdd = _ref.isAdd,
      price = _ref.price,
      ctaLabel = _ref.ctaLabel,
      _ref$prestation = _ref.prestation,
      prestation = _ref$prestation === void 0 ? '' : _ref$prestation,
      _ref$dataSelector = _ref.dataSelector,
      dataSelector = _ref$dataSelector === void 0 ? '' : _ref$dataSelector,
      _ref$ctaType = _ref.ctaType,
      ctaType = _ref$ctaType === void 0 ? '' : _ref$ctaType,
      isLoading = _ref.isLoading,
      getTrackingData = _ref.getTrackingData,
      handleClick = _ref.handleClick,
      isColumn = _ref.isColumn;
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_7__[/* useTracking */ "a"])();
  var buttonAction = isAdd ? ctaActionTypes.add : ctaActionTypes.remove;
  var label = price ? "".concat(ctaLabel, " ").concat(prestation, " ").concat(price) : ctaLabel;
  return __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_8__[/* Button */ "a"], {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_4__[/* classnames */ "a"])('w-full', {
      'sm:w-auto': !isColumn
    }),
    color: isAdd ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].BLACK : _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].BLACK,
    colorBg: isAdd ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].SAFFRON : _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].TRANSPARENT,
    colorBorder: isAdd ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].SAFFRON : _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].BLACK,
    "data-selector": "".concat(dataSelector, "-").concat(ctaType),
    isDisabled: ctaType === 'disabled',
    isLoading: isLoading,
    onClick: function onClick() {
      handleClick(buttonAction);

      if (getTrackingData) {
        track(getTrackingData(buttonAction));
      }
    }
  }, label);
};

var ButtonRenderer = function ButtonRenderer(_ref2) {
  var ctaType = _ref2.ctaType,
      ctaButton = _ref2.ctaButton,
      includedLabel = _ref2.includedLabel,
      addLabel = _ref2.addLabel,
      removeLabel = _ref2.removeLabel,
      price = _ref2.price,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_ref2, ["ctaType", "ctaButton", "includedLabel", "addLabel", "removeLabel", "price"]);

  if (ctaButton) {
    return ctaButton;
  }

  switch (ctaType) {
    case ctaActionTypes.add:
    case ctaActionTypes.disabled:
      return __jsx(AddRemoveButton, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])({
        isAdd: true,
        ctaType: ctaType,
        ctaLabel: addLabel,
        price: price ? "+".concat(price) : ''
      }, props));

    case ctaActionTypes.remove:
      return __jsx(AddRemoveButton, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])({
        ctaType: ctaType,
        ctaLabel: removeLabel,
        price: price ? "-".concat(price) : ''
      }, props));

    case ctaActionTypes.included:
      return __jsx("span", {
        className: "font-brand text-18 text-saffron"
      }, includedLabel);

    default:
      return null;
  }
};

var PaidService = function PaidService(_ref3) {
  var className = _ref3.className,
      _ref3$ctaButton = _ref3.ctaButton,
      ctaButton = _ref3$ctaButton === void 0 ? '' : _ref3$ctaButton,
      _ref3$headColor = _ref3.headColor,
      headColor = _ref3$headColor === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].SIENNA : _ref3$headColor,
      _ref3$icon = _ref3.icon,
      icon = _ref3$icon === void 0 ? null : _ref3$icon,
      _ref3$imageUrl = _ref3.imageUrl,
      imageUrl = _ref3$imageUrl === void 0 ? '' : _ref3$imageUrl,
      _ref3$isColumn = _ref3.isColumn,
      isColumn = _ref3$isColumn === void 0 ? false : _ref3$isColumn,
      _ref3$label = _ref3.label,
      label = _ref3$label === void 0 ? '' : _ref3$label,
      _ref3$reassurance = _ref3.reassurance,
      reassurance = _ref3$reassurance === void 0 ? '' : _ref3$reassurance,
      _ref3$text = _ref3.text,
      text = _ref3$text === void 0 ? '' : _ref3$text,
      _ref3$tooltip = _ref3.tooltip,
      tooltip = _ref3$tooltip === void 0 ? '' : _ref3$tooltip,
      trackOpenTooltip = _ref3.trackOpenTooltip,
      _ref3$getTrackingData = _ref3.getTrackingData,
      getTrackingData = _ref3$getTrackingData === void 0 ? '' : _ref3$getTrackingData,
      _ref3$dataSelector = _ref3.dataSelector,
      dataSelector = _ref3$dataSelector === void 0 ? 'PaidService' : _ref3$dataSelector,
      _ref3$prestation = _ref3.prestation,
      prestation = _ref3$prestation === void 0 ? '' : _ref3$prestation,
      _ref3$removeLabel = _ref3.removeLabel,
      removeLabel = _ref3$removeLabel === void 0 ? '' : _ref3$removeLabel,
      _ref3$addLabel = _ref3.addLabel,
      addLabel = _ref3$addLabel === void 0 ? '' : _ref3$addLabel,
      _ref3$price = _ref3.price,
      price = _ref3$price === void 0 ? '' : _ref3$price,
      _ref3$includedLabel = _ref3.includedLabel,
      includedLabel = _ref3$includedLabel === void 0 ? '' : _ref3$includedLabel,
      _ref3$ctaType = _ref3.ctaType,
      ctaType = _ref3$ctaType === void 0 ? ctaActionTypes.none : _ref3$ctaType,
      onClick = _ref3.onClick;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_3__["useState"])(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  Object(react__WEBPACK_IMPORTED_MODULE_3__["useEffect"])(function () {
    if (isLoading) {
      setIsLoading(false);
    }
  }, [ctaType]);

  var handleClick = function handleClick(buttonAction) {
    setIsLoading(true);
    onClick && onClick(buttonAction);
  };

  return __jsx(_frameworks_capsule_Capsule__WEBPACK_IMPORTED_MODULE_9__[/* Capsule */ "a"], {
    className: className,
    header: "none"
  }, __jsx("div", {
    className: "isolate flex-wrap sm:flex",
    "data-testid": "PaidService"
  }, !!imageUrl && !isColumn && __jsx("div", {
    className: "sm:w-2/5"
  }, __jsx(_frameworks_image_Image__WEBPACK_IMPORTED_MODULE_11__[/* Image */ "a"], {
    className: "relative h-full",
    classNameImg: "md:absolute",
    imageUrl: imageUrl,
    dimensions: {
      w: 600,
      h: 428
    },
    transformation: "resize"
  })), __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_4__[/* classnames */ "a"])('p-20', {
      'sm:w-3/5': !!imageUrl && !isColumn
    })
  }, __jsx("div", {
    className: "mb-20 flex items-center gap-10 font-brand text-18 font-bold"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_10__[/* Icon */ "a"], {
    className: "shrink-0 text-".concat(headColor),
    name: icon,
    width: "2.125rem"
  }), __jsx("div", {
    className: "leading-tight text-".concat(headColor),
    "data-testid": "PaidService-label"
  }, label), !!tooltip && __jsx(_frameworks_tooltip_Tooltip__WEBPACK_IMPORTED_MODULE_13__[/* Tooltip */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])({}, tooltip, {
    renderTrigger: function renderTrigger(toggle) {
      return __jsx("button", {
        className: "ms-10 leading-0 text-saffron",
        "data-selector": tooltip.dataSelector,
        onClick: function onClick() {
          trackOpenTooltip && trackOpenTooltip();
          toggle();
        },
        type: "button"
      }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_10__[/* Icon */ "a"], {
        name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].INFORMATION,
        width: "1.25rem"
      }));
    }
  }))), __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_12__[/* Text */ "a"], {
    text: text
  }), __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_12__[/* Text */ "a"], {
    className: "mt-10",
    text: reassurance,
    theme: "text-sans-n2"
  })), __jsx("div", {
    className: "border-t-1 p-20 sm:w-full"
  }, __jsx(ButtonRenderer, {
    ctaButton: ctaButton,
    ctaType: ctaType,
    includedLabel: includedLabel,
    price: price,
    addLabel: addLabel,
    removeLabel: removeLabel,
    prestation: prestation,
    dataSelector: dataSelector,
    isLoading: isLoading,
    getTrackingData: getTrackingData,
    handleClick: handleClick,
    isColumn: isColumn
  }))));
};

/***/ }),

/***/ "ptRt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TransfersSection_TransfersSection; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("tVqn");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/badge/Badge.jsx + 1 modules
var Badge = __webpack_require__("VHif");

// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// EXTERNAL MODULE: ./src/client/components/widgets/transport-details/transportUtils.js
var transportUtils = __webpack_require__("z8xc");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./src/client/views/booking/constants.js
var constants = __webpack_require__("taV1");

// CONCATENATED MODULE: ./src/client/components/widgets/package/transfers-section/transferUtils.js










var transferUtils_getTransferLabelKey = function getTransferLabelKey(transferType) {
  switch (transferType) {
    case constants["u" /* TRANSFER_TYPE_ENUM */].ROUND_TRIP:
      return 'common.transport.transfer.introduction';

    case constants["u" /* TRANSFER_TYPE_ENUM */].INBOUND:
      return 'common.transport.transfer.inbound';

    case constants["u" /* TRANSFER_TYPE_ENUM */].OUTBOUND:
      return 'common.transport.transfer.outbound';

    default:
      return 'common.transport.transfer.default';
  }
};

function getTransferOption(transfer) {
  var durationInMinutes = get_default()(transfer, 'productInfo.durationInMinutes');

  var durationInHours = durationInMinutes ? Object(transportUtils["p" /* transformMinutesInHours */])(durationInMinutes) : '';

  var label = get_default()(transfer, 'productInfo.label');

  return {
    value: get_default()(transfer, 'pricingInfo.id'),
    label: "".concat(label).concat(durationInHours ? ": ".concat(durationInHours) : '')
  };
}

function getCtaType(selectedTransfert, addedTransfer) {
  if (!selectedTransfert) {
    return 'disabled';
  }

  return addedTransfer ? 'remove' : 'add';
}

var transferUtils_getTransferOptions = function getTransferOptions(transfers, chooseTransfer) {
  if (isEmpty_default()(transfers)) {
    return [];
  }

  var emptyTransferOption = {
    value: '',
    label: chooseTransfer
  };
  return transfers.length === 1 ? transfers.map(getTransferOption) : [emptyTransferOption].concat(transfers.map(getTransferOption));
};

var getTransferFromValue = function getTransferFromValue(transfers, value) {
  return (transfers || []).find(function (transfer) {
    return transfer.pricingInfo.id === value;
  }) || null;
};

var transferUtils_getTransfersWithLabel = function getTransfersWithLabel(transfers) {
  return (transfers || []).filter(function (transfer) {
    return get_default()(transfer, 'productInfo.label');
  });
};

var transferUtils_getSelectedTransfer = function getSelectedTransfer(availableTransfers, selectedTransfers) {
  var validTransfers = transferUtils_getTransfersWithLabel(availableTransfers);
  var selectedTransfer = null;

  if (!isEmpty_default()(selectedTransfers)) {
    var _selectedTransfers = Object(slicedToArray["a" /* default */])(selectedTransfers, 1);

    selectedTransfer = _selectedTransfers[0];
  } else if (validTransfers.length === 1) {
    var _validTransfers = Object(slicedToArray["a" /* default */])(validTransfers, 1);

    selectedTransfer = _validTransfers[0];
  }

  return selectedTransfer;
};

var getInitiallySelectedTransfer = function getInitiallySelectedTransfer(_ref) {
  var isBE = _ref.isBE,
      addedTransfer = _ref.addedTransfer,
      selectedTransfers = _ref.selectedTransfers,
      availableTransfers = _ref.availableTransfers;

  if (isBE) {
    if (availableTransfers.length === 1) {
      return addedTransfer || availableTransfers[0];
    }

    return addedTransfer || null;
  }

  return transferUtils_getSelectedTransfer(selectedTransfers, availableTransfers);
};


// EXTERNAL MODULE: ./src/client/components/frameworks/form-validator-hoc/validationStates.js
var validationStates = __webpack_require__("45yR");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-select/InputSelect.jsx + 1 modules
var InputSelect = __webpack_require__("oWz2");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/formik-input/ErrorNote.jsx
var ErrorNote = __webpack_require__("TuHz");

// EXTERNAL MODULE: /opt/webapp/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("3yYM");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var tracking_constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// CONCATENATED MODULE: ./src/client/components/widgets/package/transfers-section/TransferSelectionButton.jsx




var __jsx = react_default.a.createElement;


/* eslint-disable clubmed/no-fake-component */






var TransferSelectionButton_TransferSelectionButton = function TransferSelectionButton(_ref) {
  var _selectedTransfer$pri, _selectedTransfer$pri2;

  var dataSelector = _ref.dataSelector,
      addedTransfer = _ref.addedTransfer,
      selectedTransfer = _ref.selectedTransfer,
      addTransfer = _ref.addTransfer,
      removeTransfer = _ref.removeTransfer,
      setHasError = _ref.setHasError;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var _React$useState = react_default.a.useState(false),
      _React$useState2 = Object(slicedToArray["a" /* default */])(_React$useState, 2),
      isLoading = _React$useState2[0],
      setIsLoading = _React$useState2[1];

  var ctaType = getCtaType(selectedTransfer, addedTransfer);
  var type = ctaType === 'disabled' ? 'add' : ctaType;
  var isAdd = type === 'add';
  var addLabel = Object(i18n["h" /* t */])("booking.transport.transfer.".concat(isAdd ? 'addTransfer' : 'removeTransfer'));
  var price = selectedTransfer === null || selectedTransfer === void 0 ? void 0 : (_selectedTransfer$pri = selectedTransfer.pricingInfo) === null || _selectedTransfer$pri === void 0 ? void 0 : (_selectedTransfer$pri2 = _selectedTransfer$pri.totalPrice) === null || _selectedTransfer$pri2 === void 0 ? void 0 : _selectedTransfer$pri2.formattedValue;
  var symbol = isAdd ? '+' : '-';
  var label = price ? "".concat(addLabel, " ").concat(symbol).concat(price) : addLabel;

  var onCtaClick = /*#__PURE__*/function () {
    var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var handler;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              handler = addedTransfer ? removeTransfer : addTransfer;
              setIsLoading(true);
              trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_UPSELL, {
                detail_click: "".concat(type, "_transfer")
              });

              if (!selectedTransfer) {
                _context.next = 8;
                break;
              }

              _context.next = 6;
              return handler(selectedTransfer);

            case 6:
              _context.next = 9;
              break;

            case 8:
              setHasError(true);

            case 9:
              setIsLoading(false);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onCtaClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  return __jsx(Button["a" /* Button */], {
    className: "w-full self-end md:w-auto",
    "data-selector": "".concat(dataSelector, "-").concat(ctaType),
    isLoading: isLoading,
    onClick: onCtaClick,
    "data-testid": isAdd ? 'transfer-add-cta' : 'transfer-remove-cta',
    size: "large"
  }, label);
};
// CONCATENATED MODULE: ./src/client/components/widgets/package/transfers-section/TransferSelection.jsx

var TransferSelection_jsx = react_default.a.createElement;

/* eslint-disable clubmed/no-fake-component */







var TransferSelection_TransferSelection = function TransferSelection(_ref) {
  var addedTransfer = _ref.addedTransfer,
      validTransfers = _ref.validTransfers,
      selectedTransfer = _ref.selectedTransfer,
      addTransfer = _ref.addTransfer,
      removeTransfer = _ref.removeTransfer,
      setSelectedTransfer = _ref.setSelectedTransfer;
  var isTransferAdded = !!addedTransfer;
  var isTransferSelected = !!selectedTransfer;
  var validationState = isTransferSelected && !isTransferAdded ? validationStates["b" /* IS_VALID */] : '';
  var transferLabel = Object(i18n["h" /* t */])(transferUtils_getTransferLabelKey(addedTransfer === null || addedTransfer === void 0 ? void 0 : addedTransfer.type));
  var dataSelector = 'transfersSection';

  var _React$useState = react_default.a.useState(false),
      _React$useState2 = Object(slicedToArray["a" /* default */])(_React$useState, 2),
      hasError = _React$useState2[0],
      setHasError = _React$useState2[1];

  var handleSelectChange = function handleSelectChange(name, value) {
    setHasError(false);
    setSelectedTransfer(getTransferFromValue(validTransfers, value));
  };

  var transfersOptions = transferUtils_getTransferOptions(validTransfers, Object(i18n["h" /* t */])('booking.transport.transfer.chooseTransfer'));
  return TransferSelection_jsx("div", {
    "data-testid": "TransferSelection",
    className: "w-full py-10"
  }, TransferSelection_jsx("div", {
    className: "gap-20 md:flex"
  }, TransferSelection_jsx("div", {
    className: "mb-15 md:mb-0 md:w-3/5"
  }, TransferSelection_jsx(InputSelect["a" /* InputSelect */], {
    label: transferLabel,
    dataTestId: "".concat(dataSelector, "TransfersOptions"),
    onChange: handleSelectChange,
    isReadOnly: isTransferAdded || isTransferSelected && validTransfers.length <= 1,
    options: transfersOptions,
    validationState: validationState,
    value: isTransferAdded ? addedTransfer.pricingInfo.id : selectedTransfer === null || selectedTransfer === void 0 ? void 0 : selectedTransfer.pricingInfo.id
  }), hasError && TransferSelection_jsx(ErrorNote["a" /* ErrorNote */], {
    className: "mx-15 md:hidden",
    isErrored: hasError,
    errorMessage: Object(i18n["h" /* t */])('booking.transport.transfer.errorTransfer')
  })), TransferSelection_jsx(TransferSelectionButton_TransferSelectionButton, {
    dataSelector: dataSelector,
    addedTransfer: addedTransfer,
    addTransfer: addTransfer,
    removeTransfer: removeTransfer,
    selectedTransfer: selectedTransfer,
    setHasError: setHasError
  })), hasError && TransferSelection_jsx(ErrorNote["a" /* ErrorNote */], {
    className: "mx-15 hidden md:block",
    isErrored: hasError,
    errorMessage: Object(i18n["h" /* t */])('booking.transport.transfer.errorTransfer')
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/package/transfers-section/TransfersSection.jsx






var TransfersSection_jsx = react_default.a.createElement;

/* eslint-disable clubmed/no-fake-component */









var TransfersSection_TransfersSection = function TransfersSection(_ref) {
  var addTransfer = _ref.addTransfer,
      availableTransfers = _ref.availableTransfers,
      removeTransfer = _ref.removeTransfer,
      selectedTransfers = _ref.selectedTransfers,
      _ref$isBE = _ref.isBE,
      isBE = _ref$isBE === void 0 ? false : _ref$isBE,
      setHasSelectedTransfer = _ref.setHasSelectedTransfer;
  var addedTransfer = selectedTransfers === null || selectedTransfers === void 0 ? void 0 : selectedTransfers[0];
  var initiallySelectedTransfer = getInitiallySelectedTransfer({
    isBE: isBE,
    addedTransfer: addedTransfer,
    selectedTransfers: selectedTransfers,
    availableTransfers: availableTransfers
  });

  var _React$useState = react_default.a.useState(initiallySelectedTransfer),
      _React$useState2 = Object(slicedToArray["a" /* default */])(_React$useState, 2),
      selectedTransfer = _React$useState2[0],
      setSelectedTransfer = _React$useState2[1];

  var _ref2 = selectedTransfer || {},
      _ref2$productInfo = _ref2.productInfo;

  _ref2$productInfo = _ref2$productInfo === void 0 ? {} : _ref2$productInfo;
  var _ref2$productInfo$dur = _ref2$productInfo.durationInMinutes,
      durationInMinutes = _ref2$productInfo$dur === void 0 ? '' : _ref2$productInfo$dur,
      vehicle = _ref2$productInfo.vehicle,
      description = _ref2$productInfo.description;

  var _ref3 = vehicle || {},
      _ref3$label = _ref3.label,
      vehicleLabel = _ref3$label === void 0 ? '' : _ref3$label;

  var shouldDisplayTransferInformationMessage = durationInMinutes || vehicleLabel;
  var durationInHours = Object(transportUtils["p" /* transformMinutesInHours */])(durationInMinutes);
  var transferInformationMessageKey = vehicleLabel ? 'durationAndMeanOfTransportation' : 'duration';
  var validTransfers = transferUtils_getTransfersWithLabel(availableTransfers);
  Object(react["useEffect"])(function () {
    if (setHasSelectedTransfer) {
      setHasSelectedTransfer(!!selectedTransfer);
    }
  }, [selectedTransfer]);

  if (isEmpty_default()(availableTransfers) && !selectedTransfer) {
    return null;
  }

  return !isEmpty_default()(validTransfers) ? TransfersSection_jsx("section", {
    className: "rounded-16 bg-lightSand p-20",
    "data-testid": "TransfersSection"
  }, TransfersSection_jsx(TransferSelection_TransferSelection, {
    addedTransfer: addedTransfer,
    validTransfers: validTransfers,
    selectedTransfer: selectedTransfer,
    addTransfer: addTransfer,
    removeTransfer: removeTransfer,
    setSelectedTransfer: setSelectedTransfer
  }), shouldDisplayTransferInformationMessage && TransfersSection_jsx("div", {
    className: "mt-20 flex gap-20"
  }, TransfersSection_jsx(Badge["a" /* Badge */], {
    className: "size-48 border-black bg-lightSand text-black",
    iconName: icons["a" /* ICONS */].CLOCK,
    iconSize: "24px",
    variant: "pill"
  }), TransfersSection_jsx("div", {
    className: "text-start text-16 leading-normal"
  }, TransfersSection_jsx(TemplateString["a" /* TemplateString */], {
    template: Object(i18n["h" /* t */])("common.transport.transfer.".concat(transferInformationMessageKey)),
    values: {
      duration: durationInHours,
      label: vehicleLabel
    },
    valuesClassName: {
      duration: 'font-bold',
      label: 'font-bold'
    }
  }), TransfersSection_jsx("p", {
    className: "mt-8 text-14 text-mediumGrey"
  }, "".concat(Object(i18n["h" /* t */])('common.transport.transfer.note').trim(), " ").concat(description)), TransfersSection_jsx("p", {
    className: "mt-8 text-14 text-mediumGrey"
  }, Object(i18n["h" /* t */])('common.transport.transfer.waitingTime'))))) : TransfersSection_jsx(Notification["a" /* Notification */], {
    className: "text-orange",
    title: Object(i18n["h" /* t */])('booking.form.errors.transferUnavailable')
  });
};

/***/ })

}]);